export const sidebarRoutes = [
  {
    title: "Dashboard",
    id: "sidebarDashboard",
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
  <path d="M2.92151 20.2941C2.32837 20.2941 1.82061 20.0733 1.39823 19.6317C0.975841 19.1902 0.764648 18.6593 0.764648 18.0392V2.2549C0.764648 1.6348 0.975841 1.10396 1.39823 0.662378C1.82061 0.220793 2.32837 0 2.92151 0H9.3921V20.2941H2.92151ZM11.549 20.2941V10.1471H20.1764V18.0392C20.1764 18.6593 19.9652 19.1902 19.5428 19.6317C19.1205 20.0733 18.6127 20.2941 18.0196 20.2941H11.549ZM11.549 7.89216V0H18.0196C18.6127 0 19.1205 0.220793 19.5428 0.662378C19.9652 1.10396 20.1764 1.6348 20.1764 2.2549V7.89216H11.549Z" fill="white"/>
</svg>`,

    subMenus: [
      {
        title: "My Dashboard",
        path: "/employee-dashboard",
      },
      {
        title: "Team Dashboard",
        path: "/my-team/my-team-dashboard",
      },
      {
        title: "Admin Dashboard",
        path: "/admin-dashboard",
      },
      // {
      //   title: "Basic Setup",
      //   path: "/basic-setup",
      //   forbiddenTo: "employee",
      // },
    ],
  },

//   {
//     title: "Applications",
//     id: "sidebarApplications",
//     icon: `<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
//   <mask id="mask0_8_330" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="28" height="28">
//     <rect width="28" height="28" fill="#D9D9D9"/>
//   </mask>
//   <g mask="url(#mask0_8_330)">
//     <path d="M6.99996 23.3333C6.35829 23.3333 5.80899 23.1048 5.35204 22.6479C4.8951 22.1909 4.66663 21.6416 4.66663 21C4.66663 20.3583 4.8951 19.809 5.35204 19.352C5.80899 18.8951 6.35829 18.6666 6.99996 18.6666C7.64163 18.6666 8.19093 18.8951 8.64788 19.352C9.10482 19.809 9.33329 20.3583 9.33329 21C9.33329 21.6416 9.10482 22.1909 8.64788 22.6479C8.19093 23.1048 7.64163 23.3333 6.99996 23.3333ZM14 23.3333C13.3583 23.3333 12.809 23.1048 12.352 22.6479C11.8951 22.1909 11.6666 21.6416 11.6666 21C11.6666 20.3583 11.8951 19.809 12.352 19.352C12.809 18.8951 13.3583 18.6666 14 18.6666C14.6416 18.6666 15.1909 18.8951 15.6479 19.352C16.1048 19.809 16.3333 20.3583 16.3333 21C16.3333 21.6416 16.1048 22.1909 15.6479 22.6479C15.1909 23.1048 14.6416 23.3333 14 23.3333ZM21 23.3333C20.3583 23.3333 19.809 23.1048 19.352 22.6479C18.8951 22.1909 18.6666 21.6416 18.6666 21C18.6666 20.3583 18.8951 19.809 19.352 19.352C19.809 18.8951 20.3583 18.6666 21 18.6666C21.6416 18.6666 22.1909 18.8951 22.6479 19.352C23.1048 19.809 23.3333 20.3583 23.3333 21C23.3333 21.6416 23.1048 22.1909 22.6479 22.6479C22.1909 23.1048 21.6416 23.3333 21 23.3333ZM6.99996 16.3333C6.35829 16.3333 5.80899 16.1048 5.35204 15.6479C4.8951 15.1909 4.66663 14.6416 4.66663 14C4.66663 13.3583 4.8951 12.809 5.35204 12.352C5.80899 11.8951 6.35829 11.6666 6.99996 11.6666C7.64163 11.6666 8.19093 11.8951 8.64788 12.352C9.10482 12.809 9.33329 13.3583 9.33329 14C9.33329 14.6416 9.10482 15.1909 8.64788 15.6479C8.19093 16.1048 7.64163 16.3333 6.99996 16.3333ZM14 16.3333C13.3583 16.3333 12.809 16.1048 12.352 15.6479C11.8951 15.1909 11.6666 14.6416 11.6666 14C11.6666 13.3583 11.8951 12.809 12.352 12.352C12.809 11.8951 13.3583 11.6666 14 11.6666C14.6416 11.6666 15.1909 11.8951 15.6479 12.352C16.1048 12.809 16.3333 13.3583 16.3333 14C16.3333 14.6416 16.1048 15.1909 15.6479 15.6479C15.1909 16.1048 14.6416 16.3333 14 16.3333ZM21 16.3333C20.3583 16.3333 19.809 16.1048 19.352 15.6479C18.8951 15.1909 18.6666 14.6416 18.6666 14C18.6666 13.3583 18.8951 12.809 19.352 12.352C19.809 11.8951 20.3583 11.6666 21 11.6666C21.6416 11.6666 22.1909 11.8951 22.6479 12.352C23.1048 12.809 23.3333 13.3583 23.3333 14C23.3333 14.6416 23.1048 15.1909 22.6479 15.6479C22.1909 16.1048 21.6416 16.3333 21 16.3333ZM6.99996 9.33329C6.35829 9.33329 5.80899 9.10482 5.35204 8.64788C4.8951 8.19093 4.66663 7.64163 4.66663 6.99996C4.66663 6.35829 4.8951 5.80899 5.35204 5.35204C5.80899 4.8951 6.35829 4.66663 6.99996 4.66663C7.64163 4.66663 8.19093 4.8951 8.64788 5.35204C9.10482 5.80899 9.33329 6.35829 9.33329 6.99996C9.33329 7.64163 9.10482 8.19093 8.64788 8.64788C8.19093 9.10482 7.64163 9.33329 6.99996 9.33329ZM14 9.33329C13.3583 9.33329 12.809 9.10482 12.352 8.64788C11.8951 8.19093 11.6666 7.64163 11.6666 6.99996C11.6666 6.35829 11.8951 5.80899 12.352 5.35204C12.809 4.8951 13.3583 4.66663 14 4.66663C14.6416 4.66663 15.1909 4.8951 15.6479 5.35204C16.1048 5.80899 16.3333 6.35829 16.3333 6.99996C16.3333 7.64163 16.1048 8.19093 15.6479 8.64788C15.1909 9.10482 14.6416 9.33329 14 9.33329ZM21 9.33329C20.3583 9.33329 19.809 9.10482 19.352 8.64788C18.8951 8.19093 18.6666 7.64163 18.6666 6.99996C18.6666 6.35829 18.8951 5.80899 19.352 5.35204C19.809 4.8951 20.3583 4.66663 21 4.66663C21.6416 4.66663 22.1909 4.8951 22.6479 5.35204C23.1048 5.80899 23.3333 6.35829 23.3333 6.99996C23.3333 7.64163 23.1048 8.19093 22.6479 8.64788C22.1909 9.10482 21.6416 9.33329 21 9.33329Z" fill="white"/>
//   </g>
// </svg>`,
//     subMenus: [
//       {
//         title: "Chat",
//         path: "/chat",
//         forbiddenTo: "admin",
//       },
//       {
//         title: "Call",
//         path: "/chat",
//         forbiddenTo: "admin",
//       },
//       {
//         title: "Email",
//         path: "/chat",
//         forbiddenTo: "admin",
//       },
//     ],
//   },
  // {
  //   title: "Employees",
  //   titleOnly: true,
  // },

  // {

  // ESS
  {
    title: "ESS",
    id: "sidebarESS",
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
  <path d="M17.3888 9.22221C17.694 9.12153 18.2059 9.3508 18.187 8.80254C18.1701 8.30411 17.697 8.52242 17.4186 8.43869C17.3799 7.09793 18.7396 5.19496 20.8031 5.04742C20.8031 5.19894 20.7991 5.34747 20.8031 5.496C20.811 5.72428 20.9392 5.85686 21.1609 5.86185C21.3746 5.86583 21.4929 5.73525 21.5107 5.52292C21.5237 5.3714 21.5276 5.21888 21.5346 5.06935C23.0444 4.94375 24.919 6.80685 24.925 8.4347C24.6437 8.53837 24.1268 8.28418 24.1338 8.83344C24.1398 9.34681 24.6377 9.12153 24.915 9.2262C24.8494 10.8839 23.2899 12.5138 21.5485 12.5856C21.4402 12.3074 21.6986 11.7871 21.144 11.8C20.642 11.812 20.8637 12.2885 20.7762 12.5636C19.5348 12.6175 17.5856 11.3574 17.3868 9.22221H17.3888ZM20.7961 8.46162C20.7961 8.70983 20.7762 8.96103 20.804 9.20626C20.819 9.33286 20.8885 9.49335 20.9869 9.56313C21.3209 9.80137 21.6767 10.0067 22.0266 10.222C22.2264 10.3447 22.4103 10.3347 22.5514 10.1313C22.6737 9.95389 22.6091 9.73857 22.3944 9.59602C22.1797 9.45348 21.964 9.30993 21.7384 9.18632C21.5764 9.0976 21.5098 8.98994 21.5177 8.79955C21.5336 8.44666 21.5227 8.09179 21.5207 7.7389C21.5187 7.49966 21.3964 7.34914 21.1569 7.35013C20.9164 7.35013 20.8001 7.50664 20.7971 7.74389C20.7941 7.98313 20.7971 8.22237 20.7971 8.46062L20.7961 8.46162Z" fill="#626262"/>
  <mask id="mask0_8_325" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
    <rect width="23.2866" height="23.2866" fill="#D9D9D9"/>
  </mask>
  <g mask="url(#mask0_8_325)">
    <path d="M11.6429 11.6433C10.5756 11.6433 9.66196 11.2633 8.90191 10.5032C8.14186 9.74319 7.76184 8.82951 7.76184 7.76221C7.76184 6.6949 8.14186 5.78123 8.90191 5.02118C9.66196 4.26113 10.5756 3.8811 11.6429 3.8811C12.7102 3.8811 13.6239 4.26113 14.384 5.02118C15.144 5.78123 15.524 6.6949 15.524 7.76221C15.524 8.82951 15.144 9.74319 14.384 10.5032C13.6239 11.2633 12.7102 11.6433 11.6429 11.6433ZM3.88074 19.4055V16.6887C3.88074 16.1389 4.02224 15.6336 4.30523 15.1727C4.58823 14.7118 4.96421 14.3601 5.43318 14.1175C6.4358 13.6162 7.45459 13.2402 8.48955 12.9896C9.52451 12.7389 10.5756 12.6136 11.6429 12.6136C12.7102 12.6136 13.7614 12.7389 14.7963 12.9896C15.8313 13.2402 16.8501 13.6162 17.8527 14.1175C18.3217 14.3601 18.6977 14.7118 18.9806 15.1727C19.2636 15.6336 19.4051 16.1389 19.4051 16.6887V19.4055H3.88074Z" fill="#626262"/>
  </g>
</svg>`,
    subMenus: [
      // {
      //   title: "Dashboard",
      //   path: "/employee-dashboard",
      //   forbiddenTo: "employee",
      // },
      {
        title: "My Profile",
        path: "/employee/profile",
      },
      {
        title: "My Portal",
        path: "/ess/my-portal",
      },
      {
        title: "My Stars",
        path: "/ess/my-stars",
      },

      // {
      //   title: "Attendance",
      //   hasSubmenus: true,
      //   icon: "la la-user-times",
      //   id: "sidebarEssAttendance",
      //   subMenus: [

      //   ],
      // },

      {
        title: "Attendance",
        path: "/attendance/my-attendance",
      },
      // {
      //   title: "Check in/out",
      //   path: "/attendance/check-in-out",
      // },
      {
        title: "Break",
        path: "/attendance/request-break-time-change",
      },
      {
        title: "Shift",
        path: "/attendance/request-shift-time-change",
      },

      {
        title: "Leaves",
        path: "/leave/my-leaves",
      },
      {
        title: "Projects",
        path: "/my-projects",
      },
      {
        title: "Letter",
        path: "/my-letter",
      },
      {
        title: "Assets and Services",
        path: "/asset-and-services/my-assets",
      },
      // {
      //   title: "My Expense Policies",
      //   path: "/ess/my-expense-policies",
      // },
      // <-- Hidden Performance Section for now
      // {
      //   title: "My Performance",
      //   id: "sidebarPerformanceAndRewards",
      //   icon: "la la-users",
      //   hasSubmenus: true,
      //   forbiddenTo: "employee",
      //   subMenus: [
      //     {
      //       title: "Overview",
      //       path: "/performance-and-rewards/dashboard",
      //     },
      //     {
      //       title: "Achievements",
      //       path: "/performance-and-rewards/achievement-list",
      //     },

      //     {
      //       title: "Disciplinary Actions",
      //       path: "/performance-and-rewards/disciplinary-action-list",
      //     },

      //     {
      //       title: "Feedback",
      //       path: "/performance-and-rewards/my-feedback",
      //     },
      //     {
      //       title: "Self Assessment",
      //       path: "/performance-and-rewards/my-assessment",
      //     },

      //     {
      //       title: "My Targets",
      //       path: "/targets/my-target",
      //     },

      //     // {
      //     //   title: "Self Assesment",
      //     //   path: "/performance-and-rewards/self-assesment",
      //     // },
      //     // {
      //     //   title: "Peer Assesment",
      //     //   path: "/performance-and-rewards/peer-assessment",
      //     // },
      //   ],
      // },
      // --/>
      // {
      //   title: "ID Card",
      //   path: "/id-card-management/id-card-ess",
      // },
      // {
      //   title: "Internal Job Openings",
      //   path: "/ess/internal-job-openings",
      // },
      // {
      //   title: "My Referrals",
      //   path: "/ess/my-referrals",
      // },

      // {
      //   title: "Probation Details",
      //   path: "/ess/my-probation-details",
      // },
      // {
      //   title: "My Loan Requests",
      //   path: "/ess/my-loan-requests",
      // },

      // {
      //   title: "My Advance Salary Requests",
      //   path: "/ess/my-advance-salary-requests",
      // },
    ],
  },

  // My team (admin)
  {
    title: "My Team",
    id: "sidebarMyTeam",
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none">
  <path d="M4 18C2.9 18 1.95833 17.6083 1.175 16.825C0.391667 16.0417 0 15.1 0 14C0 12.9 0.391667 11.9583 1.175 11.175C1.95833 10.3917 2.9 10 4 10C5.1 10 6.04167 10.3917 6.825 11.175C7.60833 11.9583 8 12.9 8 14C8 15.1 7.60833 16.0417 6.825 16.825C6.04167 17.6083 5.1 18 4 18ZM16 18C14.9 18 13.9583 17.6083 13.175 16.825C12.3917 16.0417 12 15.1 12 14C12 12.9 12.3917 11.9583 13.175 11.175C13.9583 10.3917 14.9 10 16 10C17.1 10 18.0417 10.3917 18.825 11.175C19.6083 11.9583 20 12.9 20 14C20 15.1 19.6083 16.0417 18.825 16.825C18.0417 17.6083 17.1 18 16 18ZM10 8C8.9 8 7.95833 7.60833 7.175 6.825C6.39167 6.04167 6 5.1 6 4C6 2.9 6.39167 1.95833 7.175 1.175C7.95833 0.391667 8.9 0 10 0C11.1 0 12.0417 0.391667 12.825 1.175C13.6083 1.95833 14 2.9 14 4C14 5.1 13.6083 6.04167 12.825 6.825C12.0417 7.60833 11.1 8 10 8Z" fill="black" fill-opacity="0.6"/>
</svg>`,
    forbiddenTo: "employee",
    subMenus: [
      {
        title: "Team Management",
        path: "/my-team/team-management",
      },
      {
        title: "Team Attendance",
        path: "/my-team/team-attendance",
      },
      {
        title: "Team Requests",
        path: "/my-team/team-requests",
      },
      {
        title: "Team Leave Summary",
        path: "/my-team/team-leave-summary",
      },
      {
        title: "Team Projects",
        path: "/my-team/project",
      },
      {
        title: "Team Evaluation",
        path: "/ess/manager-probation-evaluation",
      },
      {
        title: "Manage Break",
        path: "/basic-setup/break-time",
      },
      {
        title: "Manage Shift",
        path: "/basic-setup/shift-time",
      },
      {
        title: "Request Requisition",
        path: "/recruitment/recruitment-requisition",
      },
      // {
      //   title: "Request Requisition",
      //   path: "/ai-assisted-recruitment/recruitment-requisition",
      // },
      // <-- Hidden Performance Section for now
      // {
      //   title: "Team Performance",
      //   hasSubmenus: true,
      //   icon: "la la-user-times",
      //   id: "sidebarMyTeamPerformance",
      //   subMenus: [
      //     {
      //       title: "TP Overview",
      //       path: "/my-team/performance/overview",
      //     },
      //     {
      //       title: "Team Achievements",
      //       path: "/my-team/performance/achievement",
      //     },

      //     {
      //       title: "Team Disciplinary Actions",
      //       path: "/my-team/performance/disciplinary-action",
      //     },

      //     {
      //       title: "Team Evaluation",
      //       path: "/my-team/performance/assessments",
      //     },

      //     // {
      //     //   title: "Team Evaluation",
      //     //   path: "/performance-management/my-forms",
      //     // },
      //   ],
      // },
      // --/>
      // {
      //   title: "Change Break Time Requests",
      //   path: "/basic-setup/change-break-time",
      // },
      // {
      //   title: "Change Shift Time Requests",
      //   path: "/basic-setup/change-shift-time",
      // },
    ],
  },

  // Employees
  {
    title: "Employees",
    id: "sidebarEmployees",
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="12" viewBox="0 0 22 12" fill="none">
  <path d="M0 11.5V10.0563C0 9.39931 0.336111 8.86458 1.00833 8.45208C1.68056 8.03958 2.56667 7.83333 3.66667 7.83333C3.86528 7.83333 4.05625 7.83715 4.23958 7.84479C4.42292 7.85243 4.59861 7.87153 4.76667 7.90208C4.55278 8.22292 4.39236 8.55903 4.28542 8.91042C4.17847 9.26181 4.125 9.62847 4.125 10.0104V11.5H0ZM5.5 11.5V10.0104C5.5 9.52153 5.63368 9.07465 5.90104 8.66979C6.1684 8.26493 6.54653 7.90972 7.03542 7.60417C7.52431 7.29861 8.10868 7.06944 8.78854 6.91667C9.4684 6.76389 10.2056 6.6875 11 6.6875C11.8097 6.6875 12.5545 6.76389 13.2344 6.91667C13.9142 7.06944 14.4986 7.29861 14.9875 7.60417C15.4764 7.90972 15.8507 8.26493 16.1104 8.66979C16.3701 9.07465 16.5 9.52153 16.5 10.0104V11.5H5.5ZM17.875 11.5V10.0104C17.875 9.61319 17.8253 9.23889 17.726 8.8875C17.6267 8.53611 17.4778 8.20764 17.2792 7.90208C17.4472 7.87153 17.6191 7.85243 17.7948 7.84479C17.9705 7.83715 18.15 7.83333 18.3333 7.83333C19.4333 7.83333 20.3194 8.03576 20.9917 8.44063C21.6639 8.84549 22 9.38403 22 10.0563V11.5H17.875ZM3.66667 6.91667C3.1625 6.91667 2.7309 6.73715 2.37188 6.37813C2.01285 6.0191 1.83333 5.5875 1.83333 5.08333C1.83333 4.56389 2.01285 4.12847 2.37188 3.77708C2.7309 3.42569 3.1625 3.25 3.66667 3.25C4.18611 3.25 4.62153 3.42569 4.97292 3.77708C5.32431 4.12847 5.5 4.56389 5.5 5.08333C5.5 5.5875 5.32431 6.0191 4.97292 6.37813C4.62153 6.73715 4.18611 6.91667 3.66667 6.91667ZM18.3333 6.91667C17.8292 6.91667 17.3976 6.73715 17.0385 6.37813C16.6795 6.0191 16.5 5.5875 16.5 5.08333C16.5 4.56389 16.6795 4.12847 17.0385 3.77708C17.3976 3.42569 17.8292 3.25 18.3333 3.25C18.8528 3.25 19.2882 3.42569 19.6396 3.77708C19.991 4.12847 20.1667 4.56389 20.1667 5.08333C20.1667 5.5875 19.991 6.0191 19.6396 6.37813C19.2882 6.73715 18.8528 6.91667 18.3333 6.91667ZM11 6C10.2361 6 9.58681 5.73264 9.05208 5.19792C8.51736 4.66319 8.25 4.01389 8.25 3.25C8.25 2.47083 8.51736 1.81771 9.05208 1.29063C9.58681 0.763542 10.2361 0.5 11 0.5C11.7792 0.5 12.4323 0.763542 12.9594 1.29063C13.4865 1.81771 13.75 2.47083 13.75 3.25C13.75 4.01389 13.4865 4.66319 12.9594 5.19792C12.4323 5.73264 11.7792 6 11 6Z" fill="black" fill-opacity="0.6"/>
</svg>`,
    forbiddenTo: "employee",
    subMenus: [
      {
        title: "All Employees",
        path: "/employee/list-employee",
        forbiddenTo: "employee",
      },

      {
        title: "Employment",
        path: "/employment",
        forbiddenTo: "employee",
      },

      {
        title: "Shift Record",
        path: "/basic-setup/shift-assign",
      },

      {
        title: "Credentials",
        path: "/employee/credentials-management",
        forbiddenTo: "employee",
      },

      {
        title: "Off Boarding",
        path: "/employee/termination",
        forbiddenTo: "employee",
      },

      {
        title: "Contract",
        path: "/employee/contract",
        forbiddenTo: "employee",
      },
      {
        title: "Promotion",
        path: "/employee/promotion",
        forbiddenTo: "employee",
      },

      {
        title: "Probation Evaluation",
        path: "/employees/probation-evaluation",
      },
      {
        title: "Overtime",
        path: "/employees/overtime",
      },
      {
        title: "Redemption Request",
        path: "/employees/redemption-request",
      },
      {
        title: "Gate Pass Requests",
        path: "/employees/gate-pass-approvals",
      },

      {
        title: "Hired Candidates",
        path: "/employee/hired-candidates",
        forbiddenTo: "employee",
      },

      {
        title: "HR Documents",
        path: "/organization/hr-documents",
        forbiddenTo: "employee",
      },

      // {
      //   title: "Bulk Upload",
      //   path: "/employee/bulk-upload",
      // },
    ],
  },

  // Attendance
  {
    title: "Attendance",
    id: "sidebarAttendance",
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="16" viewBox="0 0 22 16" fill="none">
  <path d="M17 10V7H14V5H17V2H19V5H22V7H19V10H17ZM8 8C6.9 8 5.95833 7.60833 5.175 6.825C4.39167 6.04167 4 5.1 4 4C4 2.9 4.39167 1.95833 5.175 1.175C5.95833 0.391667 6.9 0 8 0C9.1 0 10.0417 0.391667 10.825 1.175C11.6083 1.95833 12 2.9 12 4C12 5.1 11.6083 6.04167 10.825 6.825C10.0417 7.60833 9.1 8 8 8ZM0 16V13.2C0 12.6333 0.145833 12.1125 0.4375 11.6375C0.729167 11.1625 1.11667 10.8 1.6 10.55C2.63333 10.0333 3.68333 9.64583 4.75 9.3875C5.81667 9.12917 6.9 9 8 9C9.1 9 10.1833 9.12917 11.25 9.3875C12.3167 9.64583 13.3667 10.0333 14.4 10.55C14.8833 10.8 15.2708 11.1625 15.5625 11.6375C15.8542 12.1125 16 12.6333 16 13.2V16H0Z" fill="black" fill-opacity="0.6"/>
</svg>`,
    forbiddenTo: "employee",
    subMenus: [
      // {
      //   title: "Attendance",
      //   path: "/attendance/attendance-admin",
      //   forbiddenTo: "employee",
      // },
      // {
      //   title: "Attendance Devices",
      //   path: "/attendance/devices",
      //   forbiddenTo: "employee",
      // },
      // {
      //   title: "Attendance Flags",
      //   path: "/attendance/attendance-flag",
      //   forbiddenTo: "employee",
      // },
      // {
      //   title: "Attendance History",
      //   path: "/attendance/attendance-history",
      //   forbiddenTo: "employee",
      // },

      // {
      //   title: "No Call/ No Show",
      //   path: "/attendance/ncns",
      //   forbiddenTo: "employee",
      // },

      // {
      //   title: "Check Attendance",
      //   path: "/attendance/check-attendance",
      //   forbiddenTo: "employee",
      // },
      // {
      //   title: "Check in/out",
      //   path: "/attendance/check-in-out",
      //   forbiddenTo: "admin",
      // },
      // {
      //   title: "Change Break Time",
      //   path: "/attendance/request-break-time-change",
      // },
      // {
      //   title: "Change Shift Time",
      //   path: "/attendance/request-shift-time-change",
      // },
      {
        title: "Attendance Record",
        path: "/attendance/attendance-admin",
      },
      {
        title: "Gate Pass Records",
        path: "/attendance/gate-pass-records",
      },
      {
        title: "Bulk Attendance",
        path: "/attendance/bulk-attendance",
      },
      {
        title: "Bulk Attendance Import",
        path: "/attendance/bulk-attendance-import",
      },
       {
        title: "Attendance Device Logs",
        path: "/attendance/attendance-device-logs",
      },
      {
        title: "Time Adjustment Request",
        path: "/attendance/time-adjustment-request",
      },

      // {
      //   title: "Attendance History",
      //   path: "/attendance/attendance-history",
      // },
      {
        title: "NCNS",
        path: "/attendance/ncns",
      },
      {
        title: "Suspensions",
        path: "/attendance/suspensions",
        forbiddenTo: "employee",
      },
      // {
      //   title: "Attendance Approvers",
      //   path: "/basic-setup/attendance_approvers",
      // },
      // {
      //   title: "Auto Attendance",
      //   path: "/basic-setup/auto-attendance",
      // },
      {
        title: "Roster",
        path: "/attendance/roster-view",
      },
      // {
      //   title: "Check Attendance",
      //   path: "/attendance/check-attendance",
      // },
    ],
  },

  // Remote
  {
    title: "Remote",
    id: "sidebarRemote",
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="16" viewBox="0 0 22 16" fill="none">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M11 0C7.27 0 4 2.8 4 6.25C4 10.5 11 16 11 16C11 16 18 10.5 18 6.25C18 2.8 14.73 0 11 0ZM11 8.5C9.62 8.5 8.5 7.38 8.5 6.25C8.5 5.12 9.62 4 11 4C12.38 4 13.5 5.12 13.5 6.25C13.5 7.38 12.38 8.5 11 8.5Z" fill="black" fill-opacity="0.6"/>
</svg>`,
    forbiddenTo: "employee",
    subMenus: [
      {
        title: "Geofence Creation",
        path: "/remote/geofence-creation",
      },
      {
        title: "Geofence Assignment",
        path: "/remote/geofence-assignment",
      },
    ],
  },

  {
    title: "Leave",
    id: "sidebarLeave",
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="16" viewBox="0 0 22 16" fill="none">
  <path d="M16.4 9L15 7.6L17.075 5.5L15 3.425L16.4 2L18.5 4.1L20.575 2L22 3.425L19.9 5.5L22 7.6L20.575 9L18.5 6.925L16.4 9ZM8 8C6.9 8 5.95833 7.60833 5.175 6.825C4.39167 6.04167 4 5.1 4 4C4 2.9 4.39167 1.95833 5.175 1.175C5.95833 0.391667 6.9 0 8 0C9.1 0 10.0417 0.391667 10.825 1.175C11.6083 1.95833 12 2.9 12 4C12 5.1 11.6083 6.04167 10.825 6.825C10.0417 7.60833 9.1 8 8 8ZM0 16V13.2C0 12.6333 0.145833 12.1125 0.4375 11.6375C0.729167 11.1625 1.11667 10.8 1.6 10.55C2.63333 10.0333 3.68333 9.64583 4.75 9.3875C5.81667 9.12917 6.9 9 8 9C9.1 9 10.1833 9.12917 11.25 9.3875C12.3167 9.64583 13.3667 10.0333 14.4 10.55C14.8833 10.8 15.2708 11.1625 15.5625 11.6375C15.8542 12.1125 16 12.6333 16 13.2V16H0Z" fill="black" fill-opacity="0.6"/>
</svg>`,
    forbiddenTo: "admin",

    subMenus: [
      // {
      //   title: "My Leaves",
      //   path: "/leave/my-leaves",
      //   forbiddenTo: "admin",
      // },
      {
        title: "Leave Summary",
        path: "/basic-setup/leave-assign",
      },
      {
        title: "Leave History",
        path: "/basic-setup/leave-history",
      },
      {
        title: "Bulk Leave",
        path: "/leave/bulk-leave",
      },
      {
        title: "Bulk Leave Assign",
        path: "/leave/bulk-leave-assign",
      },
      // {
      //   title: "Contractual Leave Assign",
      //   path: "/leave/contractual-leave-assign",
      // },
    ],
  },

  // Payroll
  {
    title: "Payroll",
    id: "payroll-management",
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="15" viewBox="0 0 20 15" fill="none">
  <path d="M2.66683 14.6667C2.16266 14.6667 1.73107 14.4872 1.37204 14.1281C1.01301 13.7691 0.833496 13.3375 0.833496 12.8333V1.83333C0.833496 1.32917 1.01301 0.89757 1.37204 0.538542C1.73107 0.179514 2.16266 0 2.66683 0H17.3335C17.8377 0 18.2693 0.179514 18.6283 0.538542C18.9873 0.89757 19.1668 1.32917 19.1668 1.83333V12.8333C19.1668 13.3375 18.9873 13.7691 18.6283 14.1281C18.2693 14.4872 17.8377 14.6667 17.3335 14.6667H2.66683ZM2.66683 12.8333H17.3335V3.66667H2.66683V12.8333Z" fill="#020202" fill-opacity="0.6"/>
</svg>`,
    forbiddenTo: "employee",
    subMenus: [
      {
        title: "Payroll Dashboard",
        path: "/payroll-management/payroll-dashboard",
      },
      {
        title: "Salary & Benefits",
        path: "/payroll-management/salary",
      },
      // {
      //     title: "Salary & Benefits",
      //     path: "/payroll-management/create-salary",
      // },
      {
        title: "Budget Payroll",
        path: "/payroll-management/budget-payroll",
      },
      {
        title: "Payroll Creation",
        path: "/payroll-management/generate-payroll",
      },
      {
        title: "Payroll Adjustment",
        path: "/payroll-management/payroll-adjustment",
      },
      {
        title: "Tax Override",
        path: "/payroll-management/tax-override",
      },
      {
        title: "Pending Payroll",
        path: "/payroll-management/pending-payroll",
      },
      {
        title: "Approved Payroll",
        path: "/payroll-management/approved-payroll",
      },
      {
        title: "Increment Approval List",
        path: "/payroll-management/increment-approval-list",
      },
      // {
      //   title: "Salary Slips",
      //   path: "/payroll-management/salary-slips",
      // },
      {
        title: "Payment Modes",
        path: "/payroll-management/payment-mode",
      },

      {
        title: "Loan & Advance Salary",
        path: "/payroll-management/loan-requests",
      },

      // {
      //   title: "Advance Salary Requests",
      //   path: "/payroll-management/advance-salary-requests",
      // },
    ],
  },

  // Recruitment
  {
    title: "Recruitment",
    id: "sidebarRecruitment",
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M7.2871 0C11.3271 0 14.5749 3.26341 14.5722 7.32129C14.5694 11.3258 11.2926 14.5726 7.25433 14.5715C3.26101 14.5698 -0.00463683 11.2864 0.0014734 7.27851C0.00758364 3.25286 3.26323 0 7.2871 0ZM11.832 10.6419C13.3712 8.77076 13.5612 5.32402 11.0832 3.06896C8.68523 0.887243 4.91188 1.18892 2.87162 3.72009C0.93634 6.1207 1.51126 9.22911 2.77441 10.6508C2.78163 10.5597 2.78885 10.4775 2.79441 10.3958C2.85884 9.37633 3.49264 8.52076 4.47028 8.25075C4.888 8.13575 5.34571 8.16742 5.78454 8.12408C5.92507 8.11019 5.99173 8.16686 6.05394 8.28797C6.42333 9.00855 6.80217 9.72412 7.17823 10.4414C7.20822 10.4986 7.24322 10.553 7.2871 10.6275C7.33654 10.5408 7.37542 10.4764 7.41041 10.4102C7.77981 9.70523 8.15197 9.00133 8.5147 8.29298C8.5808 8.16408 8.65635 8.11408 8.80077 8.12297C9.02185 8.1363 9.24404 8.12297 9.46568 8.12908C10.4294 8.15464 11.3032 8.77021 11.6226 9.68301C11.732 9.99579 11.767 10.3341 11.8314 10.6414L11.832 10.6419Z" fill="#5F5F5F"/>
  <path d="M12.5431 15.0898C12.7464 14.9287 12.9086 14.8009 13.0964 14.652C12.7231 14.2909 12.3909 13.9692 12.0815 13.6703C12.6165 13.1336 13.1369 12.6114 13.6724 12.0742C13.9757 12.3831 14.3001 12.7136 14.6662 13.0864C14.8028 12.9097 14.9295 12.7464 15.0761 12.5575C15.3405 12.832 15.5577 13.0647 15.7827 13.2897C16.9925 14.5003 18.2062 15.707 19.4155 16.9187C20.0299 17.5343 20.1698 18.3582 19.7916 19.0677C19.2633 20.0588 17.9274 20.3127 17.0892 19.5638C16.6814 19.1999 16.3071 18.7982 15.9199 18.411C14.8711 17.3626 13.8241 16.3126 12.7748 15.2648C12.7215 15.2115 12.6537 15.172 12.5437 15.0892L12.5431 15.0898Z" fill="#5F5F5F"/>
  <path d="M9.54349 4.97625C9.45794 5.86849 9.08466 6.81518 8.25256 7.53131C7.64376 8.05521 6.94441 8.07966 6.34839 7.54631C5.37908 6.67962 4.86027 5.58793 5.09912 4.27012C5.30076 3.15954 6.39949 2.40341 7.48933 2.52563C8.68528 2.65953 9.54848 3.61288 9.54349 4.97625Z" fill="#5F5F5F"/>
</svg>`,
    forbiddenTo: "employee",
    subMenus: [
      {
        title: "Dashboard",
        path: "/recruitment/recruitment-dashboard",
      },
      {
        title: "Job Listing",
        path: "/ai-assisted-recruitment/job-listing",
      },
      {
        title: "Requisition Planning",
        path: "/recruitment/requisition-planning",
      },
      {
        title: "Manage Applicants",
        path: "/recruitment/manage-applicants",
      },
      {
        title: "Manage Interviews",
        path: "/recruitment/open-vacancies",
      },
      {
        title: "Interview Logs",
        path: "/recruitment/interview-logs",
      },
      {
        title: "Aptitude Test",
        path: "/recruitment/aptitude-test",
      },
      {
        title: "Test Results",
        path: "/recruitment/test-results",
      },
      {
        title: "Offer Letter",
        path: "/recruitment/offer-letter-tab",
      },
      {
        title: "Resume Bank",
        path: "/recruitment/cv-bank",
      },
      {
        title: "Additional Resource Requests",
        path: "/basic-setup/additional-resource",
      },
      {
        title: "Candidate Profile",
        path: "/recruitment/candidate-information",
      },
      {
        title: "Referrals",
        path: "/recruitment/referrals",
      },
    ],
  },

  // Performance & rewards employee
  // {
  //   title: "Performance",
  //   id: "sidebarPerformanceAndRewards",
  //   icon: "la la-users",
  //   forbiddenTo: "admin",
  //   subMenus: [
  //     {
  //       title: "Dashboard",
  //       path: "/performance-and-rewards/dashboard",
  //     },
  //     {
  //       title: "Achievements",
  //       path: "/performance-and-rewards/achievement-list",
  //     },

  //     {
  //       title: "Disciplinary Actions",
  //       path: "/performance-and-rewards/disciplinary-action-list",
  //     },

  //     {
  //       title: "Feedback",
  //       path: "/performance-and-rewards/my-feedback",
  //     },
  //     {
  //       title: "My Assessment",
  //       path: "/performance-and-rewards/my-assessment",
  //     },

  //     {
  //       title: "My Targets",
  //       path: "/targets/my-target",
  //     },

  //     // {
  //     //   title: "Self Assesment",
  //     //   path: "/performance-and-rewards/self-assesment",
  //     // },
  //     // {
  //     //   title: "Peer Assesment",
  //     //   path: "/performance-and-rewards/peer-assessment",
  //     // },
  //   ],
  // },

  // Organization employee
  // {
  //   title: "Organization",
  //   id: "sidebarOrganization",
  //   icon: "la la-building",
  //   forbiddenTo: "admin",

  //   subMenus: [
  //     {
  //       title: "Handbook",
  //       path: "/organization/handbook",
  //       forbiddenTo: "admin",
  //     },
  //     {
  //       title: "HR Manual",
  //       path: "/organization/ess-hr-manual",
  //       forbiddenTo: "admin",
  //     },
  //     {
  //       title: "Handbook Details",
  //       path: "/organization/handbook-details",
  //       forbiddenTo: "employee",
  //     },
  //     {
  //       title: "HR Manual",
  //       path: "/organization/hr-manual",
  //       forbiddenTo: "employee",
  //     },
  //   ],
  // },

  // My team
  // {
  //   title: "My Team",
  //   id: "sidebarMyTeam",
  //   icon: "la la-users",
  //   forbiddenTo: "admin",
  //   subMenus: [
  //     {
  //       title: "Dashboard",
  //       path: "/my-team/my-team-dashboard",
  //     },
  //     {
  //       title: "Team Attendance",
  //       path: "/my-team/team-attendance",
  //     },
  //     {
  //       title: "Team Leave",
  //       path: "/my-team/team-leave",
  //     },
  //     {
  //       title: "Team Projects",
  //       path: "/my-team/project",
  //     },
  //     {
  //       title: "Team Probation Evaluation",
  //       path: "/ess/manager-probation-evaluation",
  //     },
  //     {
  //       title: "Break Time",
  //       path: "/basic-setup/break-time",
  //     },
  //     {
  //       title: "Shift Time",
  //       path: "/basic-setup/shift-time",
  //     },
  //     {
  //       title: "Request Requisition",
  //       path: "/recruitment/recruitment-requisition",
  //     },
  //     {
  //       title: "Team Performance",
  //       hasSubmenus: true,
  //       icon: "la la-user-times",
  //       id: "sidebarMyTeamPerformance",
  //       subMenus: [
  //         {
  //           title: "TP Overview",
  //           path: "/my-team/performance/overview",
  //         },
  //         {
  //           title: "Team Achievements",
  //           path: "/my-team/performance/achievement",
  //         },

  //         {
  //           title: "Team Disciplinary Actions",
  //           path: "/my-team/performance/disciplinary-action",
  //         },

  //         {
  //           title: "Team Evaluation",
  //           path: "/my-team/performance/assessments",
  //         },

  //         // {
  //         //   title: "Team Evaluation",
  //         //   path: "/performance-management/my-forms",
  //         // },
  //       ],
  //     },
  //   ],
  // },

  // <-- Hidden Performance Section for now
  // Performance admin
  //   {
  //     title: "Performance",
  //     id: "performance-management",
  //     forbiddenTo: "employee",
  //     icon: `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="18" viewBox="0 0 22 18" fill="none">
  //   <path d="M15.3085 11.4583L18.7918 8.47917L21.5418 8.70833L17.5085 12.2146L18.7002 17.4167L16.3627 15.9958L15.3085 11.4583ZM13.1543 4.76667L12.1918 2.52083L13.246 0L15.3543 4.97292L13.1543 4.76667ZM3.96475 17.4167L5.45433 10.9771L0.458496 6.64583L7.0585 6.07292L9.62516 0L12.1918 6.07292L18.7918 6.64583L13.796 10.9771L15.2856 17.4167L9.62516 14.0021L3.96475 17.4167Z" fill="black" fill-opacity="0.6"/>
  // </svg>`,
  //     subMenus: [
  //       {
  //         title: "Dashboard",
  //         path: "/performance-management/performance-dashboard",
  //       },

  //       {
  //         forbiddenTo: "employee",

  //         title: "Create Evaluation Forms",
  //         path: "/performance-management/evaluations-form",
  //       },

  //       {
  //         forbiddenTo: "employee",
  //         title: "Assign Form",
  //         path: "/performance-management/assign-form",
  //       },

  //       {
  //         title: "Assign Target",
  //         path: "/employee/assign-target",
  //         forbiddenTo: "employee",
  //       },

  //       {
  //         title: "Performance Report",
  //         path: "/performance-management/performance-review",
  //       },

  //       {
  //         title: "Appraisals",
  //         path: "/performance-management/appraisals",
  //       },

  //       {
  //         title: "Feedback Approvals",
  //         hasSubmenus: true,
  //         icon: "la la-user-times",
  //         id: "sidebarFeedbackApprovals",
  //         subMenus: [
  //           {
  //             title: "Achievement",
  //             path: "/performance-management/achievement-list",
  //           },

  //           {
  //             title: "Disciplinary Actions",
  //             path: "/performance-management/disciplinary-actions",
  //           },
  //           {
  //             title: "Feedback",
  //             path: "/performance-management/feedback",
  //           },
  //         ],
  //       },
  //     ],
  //   },
  // --/>

  // Assets and services
  {
    title: "Assets & Services",
    id: "sidebarAsset",
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
  <mask id="mask0_996_7" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="26" height="26">
    <rect width="25.48" height="25.48" fill="#D9D9D9"/>
  </mask>
  <g mask="url(#mask0_996_7)">
    <path d="M7.96709 15.9249H9.55959V11.6783H7.96709V13.0054H6.37459V14.5979H7.96709V15.9249ZM10.6213 14.5979H19.1146V13.0054H10.6213V14.5979ZM15.9296 11.6783H17.5221V10.3512H19.1146V8.75869H17.5221V7.4316H15.9296V11.6783ZM6.37459 10.3512H14.8679V8.75869H6.37459V10.3512ZM8.49793 22.2949V20.1716H4.25126C3.66735 20.1716 3.16748 19.9637 2.75166 19.5479C2.33584 19.1321 2.12793 18.6322 2.12793 18.0483V5.30827C2.12793 4.72435 2.33584 4.22449 2.75166 3.80867C3.16748 3.39285 3.66735 3.18494 4.25126 3.18494H21.2379C21.8218 3.18494 22.3217 3.39285 22.7375 3.80867C23.1533 4.22449 23.3613 4.72435 23.3613 5.30827V18.0483C23.3613 18.6322 23.1533 19.1321 22.7375 19.5479C22.3217 19.9637 21.8218 20.1716 21.2379 20.1716H16.9913V22.2949H8.49793Z" fill="#606060"/>
  </g>
</svg>`,
    forbiddenTo: "employee",
    subMenus: [
      {
        title: "Asset",
        path: "/asset-and-services/assets",
        forbiddenTo: "employee",
      },
      {
        title: "Service",
        path: "/asset-and-services/company-services",
        forbiddenTo: "employee",
      },
      // {
      //   title: "Service Records",
      //   path: "/asset-and-services/service-records",
      //   forbiddenTo: "employee",
      // },
      // {
      //   title: "Assign Card",
      //   path: "/asset-and-services/assign-card",
      //   forbiddenTo: "employee",
      // },
      // {
      //   title: "Card Request",
      //   path: "/asset-and-services/card-request",
      // },
      // {
      //   title: "Service Requests",
      //   path: "/asset-and-services/service-requests",
      //   forbiddenTo: "employee",
      // },
      // {
      //   title: "Request Service",
      //   path: "/asset-and-services/request-service",
      //   forbiddenTo: "admin",
      // },
      {
        title: "Inventory",
        path: "/asset-and-services/inventory",
        forbiddenTo: "employee",
      },
      {
        title: "Card",
        path: "/asset-and-services/card",
        forbiddenTo: "employee",
      },
      // {
      //   title: "Assign Inventory",
      //   path: "/asset-and-services/assign-inventory",
      //   forbiddenTo: "employee",
      // },
      // {
      //   title: "Request Inventory",
      //   path: "/asset-and-services/request-inventory",
      //   forbiddenTo: "admin",
      // },
      // {
      //   title: "Inventory Requests",
      //   path: "/asset-and-services/inventory-requests",
      //   forbiddenTo: "employee",
      // },
    ],
  },

  // Letter Management
  {
    title: "Letters",
    hasSubmenus: true,
    id: "sidebarLetterManagement",
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
  <mask id="mask0_996_14" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="25">
    <rect width="25" height="25" fill="#D9D9D9"/>
  </mask>
  <g mask="url(#mask0_996_14)">
    <path d="M12.4997 1.04163L21.9268 6.66663C22.2393 6.8576 22.4823 7.11801 22.6559 7.44788C22.8295 7.77774 22.9163 8.12496 22.9163 8.48954V19.7916C22.9163 20.3645 22.7123 20.855 22.3044 21.263C21.8964 21.671 21.4059 21.875 20.833 21.875H4.16634C3.59342 21.875 3.10297 21.671 2.69499 21.263C2.287 20.855 2.08301 20.3645 2.08301 19.7916V8.48954C2.08301 8.12496 2.16981 7.77774 2.34342 7.44788C2.51704 7.11801 2.76009 6.8576 3.07259 6.66663L12.4997 1.04163ZM12.4997 13.177L20.6247 8.33329L12.4997 3.48954L4.37467 8.33329L12.4997 13.177Z" fill="#606060"/>
  </g>
</svg>`,
    forbiddenTo: "employee",
    subMenus: [
      // {
      //   title: "Letter Applicable",
      //   path: "/letter-management/letter-applicable",
      // },
      // {
      //   title: "Letter Type",
      //   path: "/letter-management/letter-type",
      // },
      // {
      //   title: "Letter",
      //   path: "/letter-management/select-letter-type",
      // },

      // {
      //   title: "Generate Letter",
      //   path: "/letter-management/letter-generation",
      // },
      {
        title: "Add Incident",
        path: "/letter-management/add-incident",
      },
      {
        title: "Issue Letter",
        path: "/letter-management/issue-letter",
      },
      {
        title: "All Incidents & Letters",
        path: "/letter-management/all-incidents",
      },
      {
        title: "Letter Requests",
        path: "/letter-management/letter-request",
      },
      // {
      //   title: "Bulk import",
      //   path: "/letter-management/bulk-letters",
      // },
      {
        title: "All Policies",
        path: "/letter-management/all-policies",
      },
      // {
      //   title: "Add Policy",
      //   path: "/letter-management/add-policy",
      // },
      // {
      //   title: "Incident",
      //   hasSubmenus: true,
      //   icon: "la la-user-times",
      //   id: "sidebarIncident",
      //   subMenus: [
      //     {
      //       title: "Add Incident",
      //       path: "/letter-management/add-incident",
      //     },
      //     {
      //       title: "All Incidents",
      //       path: "/letter-management/all-incidents",
      //     },
      //   ],
      // },
      // {
      //   title: "Letter",
      //   hasSubmenus: true,
      //   icon: "la la-user-times",
      //   id: "sidebarLetter",
      //   subMenus: [
      //     {
      //       title: "Add Letter",
      //       path: "/letter-management/add-letter",
      //     },
      //     {
      //       title: "All Letters",
      //       path: "/letter-management/all-letters",
      //     },
      //   ],
      // },
      // {
      //   title: "Policy",
      //   hasSubmenus: true,
      //   icon: "la la-user-times",
      //   id: "sidebarPolicy",
      //   subMenus: [
      //     {
      //       title: "Add Policy",
      //       path: "/letter-management/add-policy",
      //     },
      //     {
      //       title: "All Policies",
      //       path: "/letter-management/all-policies",
      //     },
      //   ],
      // },
    ],
  },

  // Template Builder
  {
    title: "Template Builder",
    id: "sidebarTemplates",
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none">
  <rect x="3" y="3" width="18" height="18" rx="2" stroke="#606060" stroke-width="1.5"/>
  <path d="M3 9H21" stroke="#606060" stroke-width="1.5"/>
  <path d="M9 9V21" stroke="#606060" stroke-width="1.5"/>
</svg>`,
    subMenus: [
      {
        title: "Template Creation",
        path: "/templates/create",
      },
      {
        title: "Template List",
        path: "/templates",
      },
    ],
  },

  // Id Card Management
  //   {
  //     title: "ID Card Management",
  //     id: "sidebarIdCardManagement",
  //     icon: `<svg xmlns="http://www.w3.org/2000/svg" width="21" height="17" viewBox="0 0 21 17" fill="none">
  //   <path d="M12.583 9.54175H17.7913V7.45842H12.583V9.54175ZM12.583 6.41675H17.7913V4.33342H12.583V6.41675ZM3.20801 12.6667H11.5413V12.0938C11.5413 11.3126 11.1594 10.6919 10.3955 10.2319C9.63162 9.77178 8.62468 9.54175 7.37468 9.54175C6.12467 9.54175 5.11773 9.77178 4.35384 10.2319C3.58995 10.6919 3.20801 11.3126 3.20801 12.0938V12.6667ZM7.37468 8.50008C7.94759 8.50008 8.43804 8.29609 8.84603 7.8881C9.25402 7.48012 9.45801 6.98967 9.45801 6.41675C9.45801 5.84383 9.25402 5.35338 8.84603 4.94539C8.43804 4.53741 7.94759 4.33342 7.37468 4.33342C6.80176 4.33342 6.31131 4.53741 5.90332 4.94539C5.49533 5.35338 5.29134 5.84383 5.29134 6.41675C5.29134 6.98967 5.49533 7.48012 5.90332 7.8881C6.31131 8.29609 6.80176 8.50008 7.37468 8.50008ZM2.16634 16.8334C1.59342 16.8334 1.10297 16.6294 0.694987 16.2214C0.287001 15.8135 0.0830078 15.323 0.0830078 14.7501V2.25008C0.0830078 1.67716 0.287001 1.18671 0.694987 0.778727C1.10297 0.370741 1.59342 0.166748 2.16634 0.166748H18.833C19.4059 0.166748 19.8964 0.370741 20.3044 0.778727C20.7124 1.18671 20.9163 1.67716 20.9163 2.25008V14.7501C20.9163 15.323 20.7124 15.8135 20.3044 16.2214C19.8964 16.6294 19.4059 16.8334 18.833 16.8334H2.16634Z" fill="#606060"/>
  // </svg>`,
  //     forbiddenTo: "employee",
  //     subMenus: [
  //       {
  //         title: "ID Card Template",
  //         path: "/id-card-management/template",
  //       },
  //       {
  //         title: "ID Card",
  //         path: "/id-card-management/id-cards",
  //       },
  //     ],
  //   },

  // {
  //   title: "My Assets and Services",
  //   id: "sidebarAsset",
  //   icon: "la la-object-ungroup",
  //   forbiddenTo: 'admin',
  //   subMenus: [
  //     {
  //       title: "Assets and Services",
  //       path: "/asset-and-services/my-assets",
  //     },
  //   ],
  // },

  // expense
  {
    title: "Expense",
    id: "sidebarExpense",
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <mask id="mask0_expense" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
    <rect width="24" height="24" fill="#D9D9D9"/>
  </mask>
  <g mask="url(#mask0_expense)">
    <path d="M19.5 3.5L18 2L16.5 3.5L15 2L13.5 3.5L12 2L10.5 3.5L9 2L7.5 3.5L6 2L4.5 3.5L3 2V22L4.5 20.5L6 22L7.5 20.5L9 22L10.5 20.5L12 22L13.5 20.5L15 22L16.5 20.5L18 22L19.5 20.5L21 22V2L19.5 3.5ZM19 19.09H5V4.91H19V19.09ZM6 15H18V17H6V15ZM6 11H18V13H6V11ZM6 7H18V9H6V7Z" fill="#5F5F5F"/>
  </g>
</svg>`,
    forbiddenTo: "employee",
    subMenus: [
      {
        title: "Expense Categories",
        path: "/expense/expense-categories",
      },
      {
        title: "Expense Policies",
        path: "/expense/expense-policies",
      },
      {
        title: "Approval Workflow",
        path: "/expense/approval-workflow",
      },
      {
        title: "Policy Assignment",
        path: "/expense/policy-assignment",
      },
      {
        title: "Pending Approvals",
        path: "/expense/pending-approvals",
      },
      {
        title: "Expense Reimbursement",
        path: "/expense/reimbursements",
      },
      {
        title: "Expense Sheets",
        path: "/expense/expense-sheets",
      },
      // {
      //   title: "Pending Expense Sheets",
      //   path: "/expense/pending-expense-sheets",
      // },
    ],
  },

  // role
  {
    title: "Roles",
    id: "role-management",
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
  <mask id="mask0_996_26" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="25">
    <rect width="25" height="25" fill="#D9D9D9"/>
  </mask>
  <g mask="url(#mask0_996_26)">
    <path d="M17.708 21.9011C17.5691 21.9011 17.4302 21.8838 17.2913 21.849C17.1525 21.8143 17.0222 21.7536 16.9007 21.6667L13.7757 19.8438C13.5327 19.7049 13.346 19.5183 13.2158 19.2839C13.0856 19.0496 13.0205 18.7935 13.0205 18.5157V14.8438C13.0205 14.5661 13.0856 14.31 13.2158 14.0756C13.346 13.8412 13.5327 13.6546 13.7757 13.5157L16.9007 11.6928C17.0222 11.606 17.1525 11.5452 17.2913 11.5105C17.4302 11.4758 17.5691 11.4584 17.708 11.4584C17.8469 11.4584 17.9814 11.4801 18.1117 11.5235C18.2419 11.5669 18.3677 11.6233 18.4893 11.6928L21.6143 13.5157C21.8573 13.6546 22.0483 13.8412 22.1872 14.0756C22.3261 14.31 22.3955 14.5661 22.3955 14.8438V18.5157C22.3955 18.7935 22.3261 19.0496 22.1872 19.2839C22.0483 19.5183 21.8573 19.7049 21.6143 19.8438L18.4893 21.6667C18.3677 21.7362 18.2419 21.7926 18.1117 21.836C17.9814 21.8794 17.8469 21.9011 17.708 21.9011ZM2.08301 20.8334V17.9167C2.08301 17.3438 2.23058 16.8056 2.52572 16.3022C2.82086 15.7987 3.22884 15.4167 3.74967 15.1563C4.63509 14.7049 5.63335 14.323 6.74447 14.0105C7.85558 13.698 9.07954 13.5417 10.4163 13.5417H10.7809C10.8851 13.5417 10.9893 13.5591 11.0934 13.5938C10.59 14.8438 10.3816 16.0852 10.4684 17.3178C10.5552 18.5504 10.9719 19.7223 11.7184 20.8334H2.08301ZM10.4163 12.5001C9.27051 12.5001 8.28961 12.0921 7.47363 11.2761C6.65766 10.4602 6.24967 9.47925 6.24967 8.33341C6.24967 7.18758 6.65766 6.20668 7.47363 5.39071C8.28961 4.57473 9.27051 4.16675 10.4163 4.16675C11.5622 4.16675 12.5431 4.57473 13.359 5.39071C14.175 6.20668 14.583 7.18758 14.583 8.33341C14.583 9.47925 14.175 10.4602 13.359 11.2761C12.5431 12.0921 11.5622 12.5001 10.4163 12.5001ZM15.2601 14.4272L17.708 15.8595L20.1559 14.4272L17.708 13.0209L15.2601 14.4272ZM18.4893 19.8438L20.833 18.4897V15.6251L18.4893 17.0053V19.8438ZM14.583 18.4897L16.9268 19.8699V17.0313L14.583 15.6511V18.4897Z" fill="#606060"/>
  </g>
</svg>`,
    forbiddenTo: "employee",
    subMenus: [
      {
        title: "Roles & Permissions",
        path: "/role-management/roles-and-permissions",
      },
      {
        title: "Assign Role",
        path: "/role-management/assign-role",
      },
    ],
  },

  // Reports and analytics
  {
    title: "Reports & Analytics",
    id: "reports-and-analytics",
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <mask id="mask0_8_322" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
      <rect width="24" height="24" fill="#D9D9D9"/>
    </mask>
    <g mask="url(#mask0_8_322)">
      <path d="M16 20V13H20V20H16ZM10 20V4H14V20H10ZM4 20V9H8V20H4Z" fill="#5F5F5F"/>
    </g>
  </svg>`,
    forbiddenTo: "employee",
    subMenus: [
      //       {
      //         title: "Recruitment Reports",
      //         path: "/reports-and-analytics/recruitment-reports",
      //       },
      //       {
      //         title: "Employee Management Reports",
      //         path: "/reports-and-analytics/employee-management-reports",
      //       },
      //       {
      //         title: "Performance Management Reports",
      //         path: "/reports-and-analytics/performance-management-reports",
      //       },
      //       {
      //         title: "Payroll Reports",
      //         path: "/reports-and-analytics/payroll-reports",
      //       },
      //       {
      //         title: "Team Management Reports",
      //         path: "/reports-and-analytics/team-management-reports",
      //       },
      //       {
      //         title: "Additional Reports",
      //         path: "/reports-and-analytics/additional-reports",
      //       },
      //       {
      //         title: "Basic Reports",
      //         path: "/reports-and-analytics/basic-reports",
      //       },
      //       {
      //         title: "Time & Attendance Reports",
      //         path: "/reports-and-analytics/time-and-attendance-reports",
      //       },
      {
        title: "ADHOC Report",
        path: "/reports-and-analytics/adhoc-report",
      },
      {
        title: "Productive Hours Report",
        path: "/reports-and-analytics/productive-hours-report",
      },
      {
        title: "Attendance Summary",
        path: "/reports-and-analytics/attendance-summary",
      },
      {
        title: "Attendance Detail Report",
        path: "/reports-and-analytics/attendance-detail-report",
      },
      {
        title: "Attendance Consolidated Report",
        path: "/reports-and-analytics/attendance-consolidated-report",
      },
      {
        title: "Break Time Report",
        path: "/reports-and-analytics/break-time-report",
      },
      {
        title: "Leave Reports",
        path: "/reports-and-analytics/leave-reports",
      },
      {
        title: "Arrears Report",
        path: "/reports-and-analytics/arrears-report",
      },
      {
        title: "Attendance Comprehensive Report",
        path: "/reports-and-analytics/attendance-comprehensive-report",
      },
    ],
  },

  // basic setup
  // {
  //   title: "Basic Setup",
  //   id: "sidebarProjects",
  //   icon: "la la-cog",
  //   forbiddenTo: "employee",

  //   subMenus: [
  // {
  //   title: "Asset Type",
  //   path: "/basic-setup/asset-type",
  // },

  // {
  //   title: "Asset Details",
  //   path: "/basic-setup/asset-details",
  // },
  // {
  //   title: "Service Type",
  //   path: "/basic-setup/service-type",
  // },
  // {
  //   title: "Card Type",
  //   path: "/basic-setup/card",
  // },
  // {
  //   title: "Inventory Type",
  //   path: "/basic-setup/inventory-type",
  // },

  // {
  //   title: "Inventory Details",
  //   path: "/basic-setup/inventory-details",
  // },

  // {
  //   title: "Shift Assign",
  //   path: "/basic-setup/shift-assign",
  // },
  // {
  //   title: "Blood Group",
  //   path: "/basic-setup/blood-group",
  // },
  // {
  //   title: "Gender",
  //   path: "/basic-setup/gender",
  // },

  // {
  //   title: "Marital Status",
  //   path: "/basic-setup/marital-status",
  // },

  // {
  //   title: "Religion",
  //   path: "/basic-setup/religion",
  // },

  // {
  //   title: "Employment Status",
  //   path: "/basic-setup/employment-status",
  // },

  // {
  //   title: "Section",
  //   path: "/basic-setup/section",
  // },

  // {
  //   title: "Contact Relation",
  //   path: "/basic-setup/contact-relation",
  // },

  // {
  //   title: "Document Type",
  //   path: "/basic-setup/document-type",
  // },

  // {
  //   title: "Campaign",
  //   path: "/basic-setup/campaign",
  // },

  // {
  //   title: "Degree",
  //   path: "/basic-setup/degree",
  // },

  // {
  //   title: "Team",
  //   path: "/basic-setup/team",
  // },

  // {
  //   title: "Organization",
  //   path: "/basic-setup/organization",
  // },
  // {
  //   title: "Type Form",
  //   path: "/basic-setup/type-form",
  // },
  // {
  //   title: "Custom Field",
  //   path: "/basic-setup/custom-field",
  // },

  // {
  //   title: "Duty Type",
  //   path: "/basic-setup/duty-type",
  // },
  // {
  //   title: "Contract Type",
  //   path: "/basic-setup/contract-type",
  // },
  // {
  //   title: "Insurance Card",
  //   path: "/basic-setup/insurance-card",
  // },
  // {
  //   title: "Employee Project",
  //   path: "/basic-setup/employee-project",
  // },
  // {
  //       title: "Part Time",
  //       path: "/basic-setup/part-time",
  //     },
  // {
  //   title: "Break Type",
  //   path: "/basic-setup/break-type",
  // },

  // {
  //   forbiddenTo: "employee",

  //   title: "Form Frequency",
  //   path: "/performance-management/form-frequency",
  // },

  // {
  //   title: "Email Template",
  //   path: "/basic-setup/email-template",
  // },
  //   ],
  // },

  // control panel previous
  // {
  //   title: "Control Panel",
  //   id: "sidebarControlPanel",
  //   icon: "la la-toolbox",
  //   forbiddenTo: "employee",
  //   subMenus: [
  //     {
  //       title: "General Rules",
  //       hasSubmenus: true,
  //       icon: "la la-user-times",
  //       id: "sidebarGeneralSettings",
  //       subMenus: [
  //         {
  //           title: "Country",
  //           path: "/basic-setup/country",
  //         },

  //         {
  //           title: "State",
  //           path: "/basic-setup/state",
  //         },

  //         {
  //           title: "City",
  //           path: "/basic-setup/city",
  //         },

  //         {
  //           title: "Division",
  //           path: "/basic-setup/division",
  //         },

  //         {
  //           title: "Nationality",
  //           path: "/basic-setup/nationality",
  //         },

  //         {
  //           title: "Device Type",
  //           path: "/attendance/device-type",
  //         },
  //       ],
  //     },
  //     {
  //       title: "Employment Panel",
  //       hasSubmenus: true,
  //       icon: "la la-user-times",
  //       id: "sidebarEmploymentSettings",
  //       subMenus: [
  //         {
  //           title: "Employment Level",
  //           path: "/control-panel/employment-level",
  //         },
  //         {
  //           title: "Employment Grade",
  //           path: "/control-panel/employment-grade",
  //         },
  //       ],
  //     },
  //     {
  //       title: "Attendance Panel",
  //       hasSubmenus: true,
  //       icon: "la la-user-times",
  //       id: "sidebarAttendanceSettings",
  //       subMenus: [
  //         {
  //           title: "Late Coming",
  //           path: "/basic-setup/late-coming",
  //         },
  //         {
  //           title: "Half Day Policy",
  //           path: "/basic-setup/half-day-policy",
  //         },
  //         {
  //           title: "Attendance Approvers",
  //           path: "/basic-setup/attendance_approvers",
  //         },
  //         {
  //           title: "Approval Time",
  //           path: "/basic-setup/approval-time",
  //         },

  //         {
  //           title: "Approval Sandwich",
  //           path: "/basic-setup/approval-sandwich",
  //         },

  //         {
  //           title: "Late Adjustment",
  //           path: "/basic-setup/late-adjustment",
  //         },

  //         {
  //           title: "Auto Attendance",
  //           path: "/basic-setup/auto-attendance",
  //         },

  //         {
  //           title: "Auto Check Out Limit",
  //           path: "/basic-setup/auto-check-out-limit",
  //         },
  //         {
  //           title: "Part Time",
  //           path: "/basic-setup/part-time",
  //         },
  //       ],
  //     },
  //     {
  //       title: "Leave Panel",
  //       hasSubmenus: true,
  //       icon: "la la-user-times",
  //       id: "sidebarLeaveSettings",
  //       subMenus: [
  //         {
  //           title: "Leave Type",
  //           path: "/basic-setup/leave-type",
  //         },
  //         {
  //           title: "Leave Assign",
  //           path: "/basic-setup/leave-assign",
  //         },
  //         {
  //           title: "Leaves Applicable",
  //           path: "/basic-setup/leaves-applicable",
  //         },
  //         {
  //           title: "Leave Renewal",
  //           path: "/basic-setup/leave-renewal",
  //         },
  //         {
  //           title: "Leave Approver",
  //           path: "/basic-setup/leave-approver",
  //         },
  //         {
  //           title: "Leave History",
  //           path: "/basic-setup/leave-history",
  //         },
  //         {
  //           title: "Leave Approval Timeline",
  //           path: "/basic-setup/leave-approval-timeline",
  //         },
  //         {
  //           title: "Leave Request Timeline",
  //           path: "/basic-setup/leave-request-timeline",
  //         },
  //         {
  //           title: "Half Day Leave Policy",
  //           path: "/basic-setup/half-day-leave-policy",
  //         },
  //       ],
  //     },

  //     {
  //       title: "Holiday Panel",
  //       hasSubmenus: true,
  //       id: "sidebarHolidayManagement",
  //       icon: "la la-umbrella-beach",
  //       subMenus: [
  //         {
  //           title: "Weekly Holiday",
  //           path: "/holiday-management/weekly-holiday",
  //         },

  //         {
  //           title: "Gazette Holiday",
  //           path: "/holiday-management/gazette-holiday",
  //         },
  //       ],
  //     },

  //     {
  //       title: "Letter Panel",
  //       hasSubmenus: true,
  //       id: "sidebarLetterManagement",
  //       icon: "la la-envelope-open-text",
  //       forbiddenTo: "employee",
  //       subMenus: [
  //         {
  //           title: "Letter Applicable",
  //           path: "/letter-management/letter-applicable",
  //         },

  //         {
  //           title: "Letter Type",
  //           path: "/letter-management/letter-type",
  //         },

  //         {
  //           title: "Letter Generation",
  //           path: "/letter-management/letter-generation",
  //         },

  //         {
  //           title: "Letter Request",
  //           path: "/letter-management/letter-request",
  //         },

  //         {
  //           title: "Issue Letter",
  //           path: "/letter-management/issue-letter",
  //         },
  //       ],
  //     },

  //     {
  //       title: "Payroll Panel",
  //       hasSubmenus: true,
  //       icon: "la la-user-times",
  //       id: "sidebarPayrollSettings",
  //       subMenus: [
  //         {
  //           title: "Tax Slab",
  //           path: "/payroll-management/tax-slab",
  //         },
  //         {
  //           title: "Salary Type",
  //           path: "/payroll-management/salary-type",
  //         },
  //         {
  //           title: "NCNS type",
  //           path: "/payroll-management/ncns-type",
  //         },
  //         {
  //           title: "Payroll Adjustment Category",
  //           path: "/payroll-management/payroll-adjustment-category",
  //         },
  //         {
  //           title: "Provident Fund",
  //           path: "/basic-setup/provident-fund",
  //         },
  //         {
  //           title: "Bank",
  //           path: "/basic-setup/bank",
  //         },
  //       ],
  //     },
  //     {
  //       title: "Recruitment Panel",
  //       hasSubmenus: true,
  //       icon: "la la-user-times",
  //       id: "sidebarRecruitmentSettings",
  //       subMenus: [
  //         {
  //           title: "Recruitment Quota",
  //           path: "/basic-setup/recruitment-quota",
  //         },
  //         {
  //           title: "Additional Resource Requests",
  //           path: "/basic-setup/additional-resource",
  //         },
  //         {
  //           title: "Work Experience",
  //           path: "/basic-setup/experience",
  //         },
  //         {
  //           title: "Career Level",
  //           path: "/basic-setup/career-level",
  //         },
  //         {
  //           title: "Higher/Exactly",
  //           path: "/basic-setup/higher-exactly",
  //         },
  //         {
  //           title: "Interview Type",
  //           path: "/basic-setup/interview-type",
  //         },
  //       ],
  //     },
  //     {
  //       title: "Notification Panel",
  //       hasSubmenus: true,
  //       icon: "la la-user-times",
  //       id: "sidebarNotificationSettings",
  //       subMenus: [
  //         {
  //           title: "Notification type",
  //           path: "/notification-panel/notification-type",
  //         },
  //       ],
  //     },
  //   ],
  // },
  // control panel updated
  {
    title: "Control Panel",
    id: "sidebarControlPanel2",
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
  <mask id="mask0_996_41" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="26" height="26">
    <rect width="25.85" height="25.85" fill="#D9D9D9"/>
  </mask>
  <g mask="url(#mask0_996_41)">
    <path d="M5.38464 21.5421V14.0025H3.23047V11.8483H9.69297V14.0025H7.5388V21.5421H5.38464ZM5.38464 9.69413V4.30872H7.5388V9.69413H5.38464ZM9.69297 9.69413V7.53997H11.8471V4.30872H14.0013V7.53997H16.1555V9.69413H9.69297ZM11.8471 21.5421V11.8483H14.0013V21.5421H11.8471ZM18.3096 21.5421V18.3108H16.1555V16.1566H22.618V18.3108H20.4638V21.5421H18.3096ZM18.3096 14.0025V4.30872H20.4638V14.0025H18.3096Z" fill="#606060"/>
  </g>
</svg>`,
    forbiddenTo: "employee",
    subMenus: [
      {
        title: "General Settings",
        path: "/control-panel/general-settings",
      },
      {
        title: "Organization Setting",
        path: "/control-panel/organization-settings",
      },

      {
        title: "Employee Setting",
        path: "/control-panel/employee-settings",
      },

      {
        title: "Module Setting",
        path: "/control-panel/module-settings",
      },

      {
        title: "Performance Setting",
        path: "/control-panel/performance-settings",
      },

      // {
      //   title: "Approval Setting",
      //   path: "/control-panel/approval-settings",
      // },
      {
        title: "Letters Setting",
        path: "/control-panel/letter-settings",
      },

      {
        title: "Notification Setting",
        path: "/control-panel/notification-settings",
      },

      // {
      //   title: "Application Setting",
      //   path: "/control-panel/application-settings",
      // },
      // {
      //   title: "Employment Panel",
      //   hasSubmenus: false,
      //   icon: "la la-user-times",
      //   id: "sidebarEmploymentSettings",
      //   subMenus: [
      //     {
      //       title: "Employment Level",
      //       path: "/control-panel/employment-level",
      //     },
      //     {
      //       title: "Employment Grade",
      //       path: "/control-panel/employment-grade",
      //     },
      //   ],
      // },
      // {
      //   title: "Attendance Panel",
      //   hasSubmenus: true,
      //   icon: "la la-user-times",
      //   id: "sidebarAttendanceSettings",
      //   subMenus: [
      //     {
      //       title: "Late Coming",
      //       path: "/basic-setup/late-coming",
      //     },
      //     {
      //       title: "Half Day Policy",
      //       path: "/basic-setup/half-day-policy",
      //     },
      //     {
      //       title: "Attendance Approvers",
      //       path: "/basic-setup/attendance_approvers",
      //     },
      //     {
      //       title: "Approval Time",
      //       path: "/basic-setup/approval-time",
      //     },

      //     {
      //       title: "Approval Sandwich",
      //       path: "/basic-setup/approval-sandwich",
      //     },

      //     {
      //       title: "Late Adjustment",
      //       path: "/basic-setup/late-adjustment",
      //     },

      //     {
      //       title: "Auto Attendance",
      //       path: "/basic-setup/auto-attendance",
      //     },

      //     {
      //       title: "Auto Check Out Limit",
      //       path: "/basic-setup/auto-check-out-limit",
      //     },
      //     {
      //       title: "Part Time",
      //       path: "/basic-setup/part-time",
      //     },
      //   ],
      // },
      // {
      //   title: "Leave Panel",
      //   hasSubmenus: true,
      //   icon: "la la-user-times",
      //   id: "sidebarLeaveSettings",
      //   subMenus: [
      //     {
      //       title: "Leave Type",
      //       path: "/basic-setup/leave-type",
      //     },
      //     {
      //       title: "Leave Assign",
      //       path: "/basic-setup/leave-assign",
      //     },
      //     {
      //       title: "Leaves Applicable",
      //       path: "/basic-setup/leaves-applicable",
      //     },
      //     {
      //       title: "Leave Renewal",
      //       path: "/basic-setup/leave-renewal",
      //     },
      //     {
      //       title: "Leave Approver",
      //       path: "/basic-setup/leave-approver",
      //     },
      //     {
      //       title: "Leave History",
      //       path: "/basic-setup/leave-history",
      //     },
      //     {
      //       title: "Leave Approval Timeline",
      //       path: "/basic-setup/leave-approval-timeline",
      //     },
      //     {
      //       title: "Leave Request Timeline",
      //       path: "/basic-setup/leave-request-timeline",
      //     },
      //     {
      //       title: "Half Day Leave Policy",
      //       path: "/basic-setup/half-day-leave-policy",
      //     },
      //   ],
      // },

      // {
      //   title: "Holiday Panel",
      //   hasSubmenus: true,
      //   id: "sidebarHolidayManagement",
      //   icon: "la la-umbrella-beach",
      //   subMenus: [
      //     {
      //       title: "Weekly Holiday",
      //       path: "/holiday-management/weekly-holiday",
      //     },

      //     {
      //       title: "Gazette Holiday",
      //       path: "/holiday-management/gazette-holiday",
      //     },
      //   ],
      // },

      // {
      //   title: "Letter Panel",
      //   hasSubmenus: true,
      //   id: "sidebarLetterManagement",
      //   icon: "la la-envelope-open-text",
      //   forbiddenTo: "employee",
      //   subMenus: [
      //     {
      //       title: "Letter Applicable",
      //       path: "/letter-management/letter-applicable",
      //     },

      //     {
      //       title: "Letter Type",
      //       path: "/letter-management/letter-type",
      //     },

      //     {
      //       title: "Letter Generation",
      //       path: "/letter-management/letter-generation",
      //     },
      //   ],
      // },

      // {
      //   title: "Payroll Panel",
      //   hasSubmenus: true,
      //   icon: "la la-user-times",
      //   id: "sidebarPayrollSettings",
      //   subMenus: [
      //     {
      //       title: "Tax Slab",
      //       path: "/payroll-management/tax-slab",
      //     },
      //     {
      //       title: "Salary Type",
      //       path: "/payroll-management/salary-type",
      //     },
      //     {
      //       title: "NCNS type",
      //       path: "/payroll-management/ncns-type",
      //     },
      //     {
      //       title: "Payroll Adjustment Category",
      //       path: "/payroll-management/payroll-adjustment-category",
      //     },
      //     {
      //       title: "Provident Fund",
      //       path: "/basic-setup/provident-fund",
      //     },
      //     {
      //       title: "Bank",
      //       path: "/basic-setup/bank",
      //     },
      //   ],
      // },
      // {
      //   title: "Recruitment Panel",
      //   hasSubmenus: true,
      //   icon: "la la-user-times",
      //   id: "sidebarRecruitmentSettings",
      //   subMenus: [
      //     {
      //       title: "Recruitment Quota",
      //       path: "/basic-setup/recruitment-quota",
      //     },
      //     {
      //       title: "Additional Resource Requests",
      //       path: "/basic-setup/additional-resource",
      //     },
      //     {
      //       title: "Work Experience",
      //       path: "/basic-setup/experience",
      //     },
      //     {
      //       title: "Career Level",
      //       path: "/basic-setup/career-level",
      //     },
      //     {
      //       title: "Higher/Exactly",
      //       path: "/basic-setup/higher-exactly",
      //     },
      //     {
      //       title: "Interview Type",
      //       path: "/basic-setup/interview-type",
      //     },
      //   ],
      // },
      // {
      //   title: "Notification Panel",
      //   hasSubmenus: true,
      //   icon: "la la-user-times",
      //   id: "sidebarNotificationSettings",
      //   subMenus: [
      //     {
      //       title: "Notification type",
      //       path: "/notification-panel/notification-type",
      //     },
      //   ],
      // },
    ],
  },

  // Organization
  {
    title: "Organization",
    id: "sidebarOrganization",
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none">
  <path d="M0.833496 17.25V0.75H10.0002V4.41667H19.1668V17.25H0.833496ZM2.66683 15.4167H8.16683V13.5833H2.66683V15.4167ZM2.66683 11.75H8.16683V9.91667H2.66683V11.75ZM2.66683 8.08333H8.16683V6.25H2.66683V8.08333ZM2.66683 4.41667H8.16683V2.58333H2.66683V4.41667ZM10.0002 15.4167H17.3335V6.25H10.0002V15.4167ZM11.8335 9.91667V8.08333H15.5002V9.91667H11.8335ZM11.8335 13.5833V11.75H15.5002V13.5833H11.8335Z" fill="black" fill-opacity="0.6"/>
</svg>`,
    forbiddenTo: "employee",

    subMenus: [
      {
        title: "Handbook",
        path: "/organization/handbook",
        forbiddenTo: "admin",
      },
      {
        title: "Handbook Details",
        path: "/organization/handbook-details",
        forbiddenTo: "employee",
      },
      {
        title: "HR Manual",
        path: "/organization/hr-manual",
        forbiddenTo: "employee",
      },
      // {
      //   title: "HR Documents",
      //   path: "/organization/hr-documents",
      //   forbiddenTo: "employee",
      // },
      {
        title: "Notice Board",
        path: "/organization/notice-board",
        forbiddenTo: "employee",
      },
      // {
      //   title: "HR Manual",
      //   path: "/organization/ess-hr-manual",
      //   forbiddenTo: "admin",
      // },
      {
        title: "News Letter",
        path: "/organization/news-letter",
        forbiddenTo: "employee",
      }, {
        title: "Poll",
        path: "/organization/week-poll",
        forbiddenTo: "employee",
      },
    ],
  },
  // {
  //   title: "Targets",
  //   id: "sidebarTarget",
  //   icon: "la la-building",
  //   forbiddenTo: "admin",

  //   subMenus: [
  //     {
  //       title: "My Targets",
  //       path: "/targets/my-target",
  //     },
  //   ],
  // },
];

export const employeeFormFields = {
  personalInformation: [
    "profile_picture",
    "salutation_name",
    "first_name",
    "middle_name",
    "last_name",
    "husband_father_name",
    "cnic_number",
    "cnic_exp_date",
    "personal_email_address",
    "dob",
    "country_id",
    "state_id",
    "city_id",
    "marital_id",
    "gender_id",
    "religion_id",
    "nationality_id",
    "blood_group_id",
  ],
  positionalInformation: [
    "division_id",
    "pseudo_name",
    "business_email",
    "employment_status_id",
    "employee_duty_type_id",
    "contract_title",
    "contract_from",
    "contract_to",
    "shift_time_id",
    "designation_id",
    "section_id",
    "department_id",
    "team_id",
    "campaign_id",
    "probation_start_date",
    "probation_duration_month",
    "date_of_confirmation",
    "wfh",
    "hiring_date",
    "joining_date",
    "date_of_separation",
    "reporting_authority",
    "indirect_authority",
    "team_reporting",
    "start_date",
    "end_date",
  ],
  contactInformation: [
    "primary_contact_no",
    "secondary_contact_no",
    "address",
    "permanent_address",
    "present_address",
    "workplace_referrel_contact",
    "landline_no",
    "emergency[0].contact_name",
    "emergency[0].contact_number",
    "emergency[0].relation_id",
  ],
  familyInformation: [
    "spouses[0].children[0].child_dob",
    "spouses[0].children[0].child_full_name",
    "spouses[0].spouse_cnic",
    "spouses[0].spouse_dob",
    "spouses[0].spouse_full_name",
  ],
  otherInformation: [
    "passport_number",
    "passport_expiry_date",
    "driving_license_number",
    "driving_license_expiry_date",
  ],

  qualification: [
    "qualification[0].degree_end",
    "qualification[0].degree_program",
    "qualification[0].degree_start",
    "qualification[0].degree_year",
    "qualification[0].university_college_name",
  ],
  workExperience: [
    "work[0].city",
    "work[0].company_name",
    "work[0].contact_person_email",
    "work[0].contact_person_name",
    "work[0].contact_person_no",
    "work[0].country",
    "work[0].description",
    "work[0].designation",
    "work[0].experience_letter",
    "work[0].last_salary",
    "work[0].period_from",
    "work[0].period_to",
    "work[0].reason_for_leaving",
    "work[0].state",
  ],
  uploadDocument: ["documents[0].file", "documents[0].type"],
  customFields: ["custom_field[0].value"],
};

export const allPermissionsWithRoutes = {
  // Client user
  "client-dashboard": ["/client/team-dashboard"],
  "client-leave-summary": ["/client/leave-summary"],
  "clint-leave": ["/client/client-leave"],
  "client-attendance-detail-report": ["/client/attendance-detail-report"],
  "client-attendance-summary-report": ["/client/attendance-summary-report"],
  "client-employee-list": ["/client/team-management", "/client/user-profile"],
  "client-attendance": "/client/team-attendance",
  // Super Admin
  "super-admin-access": "/role-management/module-based-access",
  // Dashboard
  "dashboard-admin": [
    "/admin-dashboard",
    "/performance-and-rewards/dashboard",
    "/reports-and-analytics/recruitment-reports",
    "/reports-and-analytics/employee-management-reports",
    "/reports-and-analytics/performance-management-reports",
    "/reports-and-analytics/payroll-reports",
    "/reports-and-analytics/team-management-reports",
    "/reports-and-analytics/additional-reports",
    "/reports-and-analytics/basic-reports",
    "/reports-and-analytics/time-and-attendance-reports",
    "/chat",
    "/reports-and-analytics/adhoc-report",
    "/organization/news-letter",
    "/organization/week-poll",
    "/employee/contract",
    // "/leave/contractual-leave-assign"
  ],
  "dashboard-employee": [
    "/employee-dashboard",
    "/notifications",
    "/attendance/request-break-time-change",
    "/attendance/request-shift-time-change",
    "/two-factor-authentication",
    // AI Assisted Recruitment
    // "/ai-assisted-recruitment/job-listing",
    // "/ai-assisted-recruitment/aptitude-test",
  ],
  // Gate Pass
  "gatepass-list": ["/ess/my-gate-pass-records", "/ess/my-portal"],
  "gatepass-manager-list": [
    "/my-team/gate-pass-requests",
    "/my-team/team-requests",
  ],
  "gatepass-hr-list": "/employees/gate-pass-approvals",
  "gatepass-global-parameters-show": "/control-panel/general-settings",
  "gatepass-division-setting-list": "/control-panel/general-settings",
  "gatepass-attendance-list": "/attendance/gate-pass-records",
  // AI Assisted Recruitment - Job Listing tabs
  "ai_recruitment_requisition-assigned": [
    "/ai-assisted-recruitment/job-listing",
    "/ai-assisted-recruitment/aptitude-test",
  ],
  "ai_recruitment_requisition-published": [
    "/ai-assisted-recruitment/job-listing",
    "/ai-assisted-recruitment/aptitude-test",
  ],
  "ai_recruitment_requisition-open": [
    "/ai-assisted-recruitment/job-listing",
    "/ai-assisted-recruitment/aptitude-test",
  ],
  "ai_recruitment_requisition-closed": [
    "/ai-assisted-recruitment/job-listing",
    "/ai-assisted-recruitment/aptitude-test",
  ],
  // ESS
  // - My profile
  "ess-my-profile": ["/employee/profile", "/payroll-management/payroll/salary-slip-user-view/:id"],
  // - My portal
  "ess-ess-id-card-list": "/ess/my-portal",
  "internal_job_opening_management-list": "/ess/my-portal",
  "internal_job_opening_management-referred": "/ess/my-portal",
  "loan_request-loan-request-list": "/ess/my-portal",
  "advance_salary_request-advance-salary-request-list": "/ess/my-portal",
  // - My stars
  "earn_stars-user-earn-star-list": "/ess/my-stars",
  "add_offer-list": "/ess/my-stars",
  "earn_stars-user-redemption-list": "/ess/my-stars",
  // - Attendance
  "ess-attendance-employee": "/attendance/my-attendance",
  "attendance_add-attendance-in": "/attendance/check-in-out",
  "attendance_add-attendance-out": "/attendance/check-in-out",
  "change-break-timing-team": "/basic-setup/break-time",
  // "change-break-timing-user": "/attendance/request-break-time-change",

  // "change-shift-timing-user": "/attendance/request-shift-time-change",
  "change-shift-timing-team": "/basic-setup/shift-time",
  "ess-check-attendance": "/attendance/check-attendance", // not included for now as per BA's requirments
  // - Leave
  "ess-leave": "/leave/my-leaves", // until ess letter permission is added
  // - projects
  "ess-project": "/my-projects",
  // - letter
  "my-letters-list": "/my-letter",
  "my-letter-requests-list": "/my-letter",
  "incident-letter-create": ["/letter-management/issue-letter", "/letter-management/correct-letter/:id"],
  "incident-list": "/letter-management/all-incidents",
  "letter-request-list": "/letter-management/letter-request",
  // "letter-request-issue": "/letter-management/issue-letter/:employeeId/:requestId",
  "incident-create": ["/letter-management/add-incident", "/letter-management/update-incident/:id", "/letter-management/correct-letter/:id",],
  "policy-list": "/letter-management/all-policies",
  "policy-create": "/letter-management/add-policy",
  "policy-edit": "/letter-management/update-policy/:id",
  // "letter_issuance-list": [




  // "/letter-management/all-letters",
  // "/letter-management/select-letter-type",
  // "/letter-management/incident-types",
  // "/letter-management/bulk-letters",
  // ],
  // - assets and services
  "ess-asset": "/asset-and-services/my-assets",
  // - my performance
  // - my performance dashboard remaining
  "achievement-list": [
    "/performance-and-rewards/achievement-list",
    "/my-team/performance/achievement",
    "/performance-management/achievement-list",
  ],
  "disciplinary_action-list": [
    "/performance-and-rewards/disciplinary-action-list",
    "/my-team/performance/disciplinary-action",
    "/performance-management/disciplinary-actions",
  ],
  "project_types-performance-feedback-type-list":
    "/performance-and-rewards/my-feedback",
  "peer_assessment-list": "/performance-and-rewards/my-assessment",
  "self_assessment-list": "/performance-and-rewards/my-assessment",

  // MY TEAM
  // - dashboard (pending)
  "my_team_dashboard-total-active-all-employee": [
    "/my-team/my-team-dashboard",
    "/my-team/team-management",
  ],
  "time_adjustment_request-manager-list":[
    "/my-team/team-time-adjustment",
    "/my-team/team-requests",
  ],
  "my_team_dashboard-total-active-all-employee-list":
    "/my-team/my-team-dashboard",
  "my_team_dashboard-total-absent-all-employee": "/my-team/my-team-dashboard",
  "my_team_dashboard-all-employee-project": "/my-team/my-team-dashboard",
  "my_team_dashboard-all-employee-wfh": "/my-team/my-team-dashboard",
  "my_team_dashboard-all-employee-time-adjustment":
    "/my-team/my-team-dashboard",
  "my_team_dashboard-total-absent-all-employee-list":
    "/my-team/my-team-dashboard",
  "my_team_dashboard-all-employee-wfh-list": "/my-team/my-team-dashboard",
  "my_team_dashboard-all-employee-time-adjustment-list":
    "/my-team/my-team-dashboard",
  "my_team_dashboard-all-employee-adjustment-approve":
    "/my-team/my-team-dashboard",
  "my_team_dashboard-all-employee-today-leave": "/my-team/my-team-dashboard",
  "my_team_dashboard-all-employee-tomorrow-leave": "/my-team/my-team-dashboard",
  "my_team_dashboard-all-employee-up-coming-leave":
    "/my-team/my-team-dashboard",
  "my_team_dashboard-all-employee-current-month-leave":
    "/my-team/my-team-dashboard",
  "my_team_dashboard-all-employee-new-joining": "/my-team/my-team-dashboard",
  "my_team_dashboard-all-employee-birthday": "/my-team/my-team-dashboard",
  "my_team_dashboard-all-employee-anniversary": "/my-team/my-team-dashboard",
  "my_team_dashboard-all-employee-current-month-leave-list":
    "/my-team/my-team-dashboard",
  "my_team_dashboard-all-employee-separation-date":
    "/my-team/my-team-dashboard",
  "my_team_dashboard-total-all-employee-list": "/my-team/my-team-dashboard",
  // - team attendance (pending)
  // - team leave
  "my_team_dashboard-all-employee-leave-team": [
    "/my-team/team-attendance",
  ],
  "team_leave-summary_list":[
    "/my-team/team-leave-summary",
  ],
  "team_leave-history_list":[
     "/my-team/team-leave-history",
     "/my-team/team-requests",
  ],
  // - team project
  "project-list": [
    "/my-team/project",
    "/my-team/project/:id",
    "/employee/profile/project-tasks/:id",
  ],
  // - team evaluation
  "probation_evaluation_form-pending-under-probation-evaluation":
    "/ess/manager-probation-evaluation",
  "probation_evaluation_form-probation-evalution-hr-request-clarification-list":
    "/ess/manager-probation-evaluation",
  // - break
  "assign_break-list": "/basic-setup/break-time",
  // "change_break_timing-list": "/basic-setup/break-time",
  // - shift
  "assign_shift-list": "/basic-setup/shift-time",
  // "change_shift_timing-list": "/basic-setup/shift-time",
  // - recruitment requisition
  "recruitment_requisition-list": ["/recruitment/recruitment-requisition"],
  // - AI recruitment requisition
  "ai_recruitment_requisition-list": ["/ai-assisted-recruitment/recruitment-requisition"],
  // - team performance
  "specific_goal-list": "/my-team/performance/overview",
  "assign_employee_target-list": "/my-team/performance/overview",
  // "achievement-list": "/my-team/performance/achievement",
  // "disciplinary_action-list": "/my-team/performance/disciplinary-action",
  "assign_form-get-assigned-employees-assessed":
    "/my-team/performance/assessments",

  // EMPLOYEE MANAGEMENT
  // - all employees
  "employee-list": [
    "/employee/list-employee",
    "/employment",
    "/employee/edit-employee/:id",
  ],
  // - employment
  // "employee-list": "/employment",
  // - attendance
  "improt-attendance_bulk": [
    "/attendance/bulk-attendance",
    "/attendance/bulk-attendance-import",
  ],
  "attendance_history-list": [
    "/attendance/attendance-history",
  ],
  "time_adjustment_request-admin-list": "/attendance/time-adjustment-request",
  "NCNS-list": ["/attendance/ncns"],
  "suspensions-list": ["/attendance/suspensions"],
  "auto_attendance-list": "/basic-setup/auto-attendance",
  "ess-attendance-admin": ["/attendance/attendance-admin",],
  // "ess-attendance-admin": ["/attendance/attendance-admin", "/attendance/roster", "/attendance/bulk-add-roster" , "/attendance/roster-add", "/attendance/roster-view", "/attendance/bulk-update-roster/:id"],
  "roster-view": ["/attendance/roster-view"],
  "roster-add": ["/attendance/roster-add"],
  "roster-bulk-add": ["/attendance/bulk-add-roster"],

  "dat-attendance-import": "/attendance/attendance-device-import",
  "attendance-machine-history": "/attendance/attendance-device-logs",
  // - leave
  "leave_assign-list": ["/basic-setup/leave-assign", "/leave/bulk-leave-assign",],
  "leave_history-list": ["/basic-setup/leave-history", "/leave/bulk-leave"],
  // - shift record
  "shift_assign-list": "/basic-setup/shift-assign",
  // - credentials
  "employee_credential-list": "/employee/credentials-management",
  // - off boarding
  "employee_termination-list": ["/employee/termination", "/employee/promotion"],
  // - probation evaluation
  "probation_evaluation_employee-detail": "/employees/probation-evaluation",
  // - overtime
  "overtime_rates-overtime-list": "/employees/overtime",
  // - redemption request
  "redemption_request-redemption-request-list": "/employees/redemption-request",
  // - hired candidates
  "offer_letter-list": [
    "/employee/hired-candidates",
    "/recruitment/offer-letter-tab",
  ],

  // PAYROLL MANAGEMENT
  // - salary benefits
  "salary_benefit-list": "/payroll-management/salary",
  // - budget payroll
  // - payroll creation
  // - payroll adjustment
  // - pending payroll
  // - approved payroll
  "payroll-create": [
    "/payroll-management/budget-payroll",
    "/payroll-management/generate-payroll",
    "/payroll-management/payroll-adjustment",
    "/payroll-management/pending-payroll",
    "/payroll-management/approved-payroll",
  ],
  "tax_override-list": "/payroll-management/tax-override",
  "payroll_increment-approval-list": "/payroll-management/increment-approval-list",
  // "payroll-create": "/payroll-management/generate-payroll",
  // "payroll-create": "/payroll-management/payroll-adjustment",
  // "payroll-create": "/payroll-management/pending-payroll",
  // "payroll-create": "/payroll-management/approved-payroll",
  // - payment mode
  "payroll-list-approved": "/payroll-management/payment-mode",
  // - loan & advance salary
  "loan_request-records-list": "/payroll-management/loan-requests",
  "loan_request-list": "/payroll-management/loan-requests",
  "advance_salary_request-records-list": "/payroll-management/loan-requests",
  "advance_salary_request-list": "/payroll-management/loan-requests",

  // RECRUITMENT MANAGEMENT
  // - recruitment planning
  "recruitment_requisition-check-requisitions-list":
    "/recruitment/requisition-planning",
  "recruitment_requisition-publish-vacancy-list":
    "/recruitment/requisition-planning",
  "Apply_job_candidate-shortlisted-candidate-list": [
    "/recruitment/requisition-planning",
    "/recruitment/manage-applicants",
  ],
  "Apply_job_candidate-shortlisted-applied":
    "/recruitment/requisition-planning",
  "offer_letter-offer-letter-list-approve": "/recruitment/requisition-planning",
  // - manage applicants
  // "Apply_job_candidate-shortlisted-candidate-list":
  //   "/recruitment/manage-applicants",
  "Apply_job_candidate-apply-candidate-list": "/recruitment/manage-applicants",
  "Apply_job_candidate-on-hold-candidate-list":
    "/recruitment/manage-applicants",
  "Apply_job_candidate-rejected-candidate-list":
    "/recruitment/manage-applicants",
  "scheduled_interview-list": [
    "/recruitment/manage-applicants",
    "/recruitment/open-vacancies",
  ],
  // - manage interviews
  // "scheduled_interview-list": "/recruitment/open-vacancies",
  "scheduled_interview-hire-candidates-list": "/recruitment/open-vacancies",
  "scheduled_interview-reject-candidates-list": "/recruitment/open-vacancies",
  "scheduled_interview-on-hold-interview-list": "/recruitment/open-vacancies",
  "scheduled_interview-blacklist-interview-list": "/recruitment/open-vacancies",
  // - offer letter
  // "offer_letter-list": "/recruitment/offer-letter-tab",
  "offer_letter-offer-letter-list-approve": "/recruitment/offer-letter-tab",
  // - interview logs
  "scheduled_interview-interview-log": "/recruitment/interview-logs",
  // - aptitude test
  "aptitude_test-list": [
    "/recruitment/aptitude-test",
    "/recruitment/test-results",
  ],
  // - resume bank
  "Apply_job_candidate-move-cv-list": "/recruitment/cv-bank",
  // - additional resource resource
  "additional_resource_quota-list": "/basic-setup/additional-resource",
  // - candidate information
  "Apply_job_candidate-shortlisted-applied":
    "/recruitment/candidate-information",
  // - candidate information
  "internal_job_opening_management-refer-candidate-list":
    "/recruitment/referrals",

  // PERFORMANCE MANAGEMENT
  // - create evaluation forms
  "performance_managment-list": [
    "/performance-management/evaluations-form",
    "/performance-management/create-evaluation-form",
  ],
  // - assign form
  "assign_form-list": "/performance-management/assign-form",
  "assign_form-get-assigned-form-employees":
    "/performance-management/assign-form",
  "assign_form-get-assign-form-non-assigned-employees":
    "/performance-management/assign-form",
  // - assign target
  "assign_target-list": ["/employee/assign-target", "/targets/my-target"],
  // - performance review
  "performance_review_submission-employee-reviewed-list":
    "/performance-management/performance-review",
  // - appraisals
  "performance_review_submission-employee-appraisal-list":
    "/performance-management/appraisals",
  "performance_review_submission-employee-appraisal-list-approved":
    "/performance-management/appraisals",
  // - feedback approvals
  // "achievement-list": "/performance-management/achievement-list",
  // "disciplinary_action-list": "/performance-management/disciplinary-actions",
  "project_types-peformance-feedback-list": "/performance-management/feedback",

  // ASSETS AND SERVICES
  // - assets
  "asset-list": "/asset-and-services/assets",
  "asset_request-list": "/asset-and-services/assets",
  // - services
  "service-list": "/asset-and-services/company-services",
  "assign_service-list": "/asset-and-services/company-services",
  "service_request-list": "/asset-and-services/company-services",
  // - inventory
  "inventory-list": "/asset-and-services/inventory",
  "assign_inventory-list": "/asset-and-services/inventory",
  "inventory_request-list": "/asset-and-services/inventory",
  // - card
  "card-list": "/asset-and-services/card",
  "assign_card-list": "/asset-and-services/card",
  "card_request-list": "/asset-and-services/card",

  // LETTER MANAGEMENT
  // - generate letter
  "letter_generation-list": "/letter-management/letter-generation",
  // - issue letter
  // "letter_issuance-list": "/letter-management/issue-letter",
  // - request letter
  // "letter_issuance-list": "/letter-management/letter-request", // permission missing

  // ID CARD MANAGEMENT
  // - id card template
  // "id_card_management-id-card-list": "/id-card-management/template", // permission missing
  // - id card
  "id_card_management-id-card-list": [
    "/id-card-management/id-cards",
    "/id-card-management/template",
  ],

  // ROLES AND PERMISSIONS
  // - roles and permissions
  "role_permission-list": [
    "/role-management/roles-and-permissions",
    "/role-management/add-role",
    "/role-management/edit-role/:id",
  ],
  // - assign role
  "role_permission-role-assign-list": "/role-management/assign-role",

  // CONTROL PANEL
  // - general settings
  "country-list": "/control-panel/general-settings",
  "state-list": "/control-panel/general-settings",
  "city-list": "/control-panel/general-settings",
  "nationality-list": "/control-panel/general-settings",
  "blood_group-list": "/control-panel/general-settings",
  "gender-list": "/control-panel/general-settings",
  "marital_status-list": "/control-panel/general-settings",
  "religion-list": "/control-panel/general-settings",
  "contact_relation-list": "/control-panel/general-settings",
  "custom_field-list": "/control-panel/general-settings",
  "attendance_device-list": "/control-panel/general-settings",
  "device_type-list": "/control-panel/general-settings",
  // - organization settings
  // "organization-list": "/control-panel/organization-settings",
  "division-list": "/control-panel/organization-settings",
  "department-list": "/control-panel/organization-settings",
  "section-list": "/control-panel/organization-settings",
  "campaign-list": "/control-panel/organization-settings",
  "employee_project-list": "/control-panel/organization-settings",
  "team-list": "/control-panel/organization-settings",
  "designation-list": "/control-panel/organization-settings",
  "auto_checkout_mail_setting-list": "/control-panel/organization-settings",
  // - employee settings
  "type_form-list": "/control-panel/employee-settings",
  "performance_form_frequency-list": "/control-panel/employee-settings",
  "shift_timing-list": "/control-panel/employee-settings",
  "break-list": "/control-panel/employee-settings",
  "asset_type-list": "/control-panel/employee-settings",
  "asset_details-list": "/control-panel/employee-settings",
  "service-list": "/control-panel/employee-settings",
  "card-list": "/control-panel/employee-settings",
  "inventory-list": "/control-panel/employee-settings",
  "inventory_detail-list": "/control-panel/employee-settings",
  "employment_level-list": "/control-panel/employee-settings",
  "employment_grade-list": "/control-panel/employee-settings",
  "employee_duty_type-list": "/control-panel/employee-settings",
  "employment_status-list": "/control-panel/employee-settings",
  "contract-list": "/control-panel/employee-settings",
  "mail_template-list": "/control-panel/employee-settings",
  //  - Template 
  "template-list": ["/templates", "/templates/:id/view"],
  "template-create": "/templates/create",
  "template-update": "/templates/:id/edit",
  "off_boarding_leave_setting-list": "/control-panel/employee-settings",
  "performance_rating-list": "/control-panel/employee-settings",
  "document_type-list": "/control-panel/employee-settings",
  "overtime_rates-list": "/control-panel/employee-settings",
  // - module settings
  "ncns_type-list": "/control-panel/module-settings",
  "attendance_flag-list": "/control-panel/module-settings",
  "half_day_policy-list": "/control-panel/module-settings",
  "late_coming-list": "/control-panel/module-settings",
  "auto_check_out_limit-list": "/control-panel/module-settings",
  "late_adjustment_request-list": "/control-panel/module-settings",
  // "NCNS-list": "/control-panel/module-settings",
  "leave_type-list": "/control-panel/module-settings",
  "weekly_holidays-list": "/control-panel/module-settings",
  "gazette_holiday-list": "/control-panel/module-settings",
  "leave_approval_time_line-list": "/control-panel/module-settings",
  "leave_request_time_line-list": "/control-panel/module-settings",
  "half_day_leave_policy-list": "/control-panel/module-settings",
  "leave_renewal-list": "/control-panel/module-settings",
  "leave_applicable-list": "/control-panel/module-settings",
  "leave_duty_type-leave-duty-type-full-time-list":
    "/control-panel/module-settings",
  "leave_duty_type-leave-duty-type-part-time-list":
    "/control-panel/module-settings",
  "payroll_adjustment_category-list": "/control-panel/module-settings",
  "salary_type-list": "/control-panel/module-settings",
  "advance_salary_percentage-list": "/control-panel/module-settings",
  "provident_fund-list": "/control-panel/module-settings",
  "tax_slab-list": "/control-panel/module-settings",
  "bank-list": "/control-panel/module-settings",
  "recruitment_career_level-list": "/control-panel/module-settings",
  "recruitment_experience-list": "/control-panel/module-settings",
  "interview_type-list": "/control-panel/module-settings",
  "recruitment_higher_exactly-list": "/control-panel/module-settings",
  "recruitment_quota-list": "/control-panel/module-settings",
  "degree-list": "/control-panel/module-settings",
  "test_type-list": "/control-panel/module-settings",
  // - performance settings
  "add_offer-list": "/control-panel/performance-settings",
  "earn_stars-list": "/control-panel/performance-settings",
  // - approval settings
  "leave_approver-list": "/control-panel/approval-settings",
  "attendance_approval-list": "/control-panel/approval-settings",
  "approval_time-list": "/control-panel/approval-settings",
  "approval_sandwich-list": "/control-panel/approval-settings",
  // - letter settings
  "letter_applicable-list": "/control-panel/letter-settings",
  "incident_type-list": "/control-panel/letter-settings",
  "letter_template-list": "/control-panel/letter-settings",
  "letter_type-list": [
    "/control-panel/letter-settings",
    "/control-panel/notification-settings",
    "/control-panel/application-settings",
  ],
  // - Geofence Module
  "geofencing-get-global-geofence-status": [
    "/basic-setup/geo-fencing",
    "/basic-setup/geo-fencing/create",
    "/basic-setup/geo-fencing/edit/:id",
    "/basic-setup/geo-fencing/map/:id",
    "/remote/geofence-creation",
    "/remote/geofence-assignment",
  ],
  // - notification settings
  // "pending": "/control-panel/notification-settings",
  // - application settings
  // "pending": "/control-panel/application-settings",

  // ORGANIZATION
  // - handbook details
  "organization-list": [
    "/organization/handbook-details",
    "/control-panel/organization-settings",
  ], // permission missing
  //notice-board
  "organization-notice_board_list": [
    "/organization/notice-board",
  ],
  "ess-notice-board-list": [
    "/organization/notice-board",
  ],
  // - hr documents
  "hr_documents-list": ["/organization/hr-documents"],
  // - hr manual
  "hr_manual-list": "/organization/hr-manual",
  //news-letter
  "news_letter-list": "/organization/news-letter",
  //poll
  "week_poll-list": "/organization/week-poll",
  // - handbook
  "organization-handbook": "/organization/handbook",
  "ess-hr-manual": "/organization/hr-manual",

  // REPORTS AND ANALYTICS
  // - Attendance Reports
  "attendance_reports-productive-hour-report": [
    "/reports-and-analytics/productive-hours-report",
  ],
  "attendance_reports-attendance-detail-report": [
    "/reports-and-analytics/attendance-detail-report",
  ],
  "attendance_reports-attendance-consolidated-report": [
    "/reports-and-analytics/attendance-consolidated-report",
  ],
  "attendance_reports-attendance-summary-report": [
    "/reports-and-analytics/attendance-summary",
  ],
  "attendance_reports-break-time-report": [
    "/reports-and-analytics/break-time-report",
  ],
  "payroll_reports-arrears-report": [
    "/reports-and-analytics/arrears-report",
  ],
  "leave_reports-leave-summary-report": [
    "/reports-and-analytics/leave-reports",
  ],
  "leave_reports-leave-detail-report": [
    "/reports-and-analytics/leave-reports",
  ],
  "attendance_reports-comprehensive-report": [
    "/reports-and-analytics/attendance-comprehensive-report",
  ],

  // Expense
  "expense_category-list": "/expense/expense-categories",
  "expense_category-create": "/expense/expense-categories",
  "expense_category-edit": "/expense/expense-categories",
  "expense_category-delete": "/expense/expense-categories",
  "expense_category-status-update": "/expense/expense-categories",
  "expense_policy-list": "/expense/expense-policies",
  "expense_policy-create": "/expense/expense-policies",
  "expense_policy-edit": "/expense/expense-policies",
  "expense_policy-delete": "/expense/expense-policies",
  "expense_policy-status-update": "/expense/expense-policies",
  "expense_approval_level-list": "/expense/approval-workflow",
  "expense_approval_level-create": "/expense/approval-workflow",
  "expense_approval_level-reorder": "/expense/approval-workflow",
  "expense_approval_level-delete": "/expense/approval-workflow",
  "expense_policy_assignment-list": [
    "/expense/policy-assignment",
    "/ess/my-expense-policies",
  ],
  "expense_policy_assignment-create": "/expense/policy-assignment",
  "expense_policy_assignment-edit": "/expense/policy-assignment",
  "expense_policy_assignment-delete": "/expense/policy-assignment",
  "expense_policy_grade_assignment-list": [
    "/expense/policy-assignment",
    "/ess/my-expense-policies",
  ],
  "expense_policy_grade_assignment-create": "/expense/policy-assignment",
  "expense_policy_grade_assignment-edit": "/expense/policy-assignment",
  "expense_policy_grade_assignment-delete": "/expense/policy-assignment",
  "expense_claim-list": ["/ess/my-claims", "/ess/my-portal"],
  "expense_claim-create": "/ess/my-claims",
  "expense_sheet-list": [
    '/expense/expense-sheets',
    '/expense/expense-sheet-detail',
  ],
  "expense_claim-view": "/ess/my-claims",
  "expense_claim-edit": "/ess/my-claims",
  "expense_claim-submit": "/ess/my-claims",
  "expense_claim-delete": "/ess/my-claims",
  "expense_claim_approval-list": "/expense/pending-approvals",
  "expense_claim_approval-approve": "/expense/pending-approvals",
  "expense_claim_approval-reject": "/expense/pending-approvals",
  "expense_claim_approval-return": "/expense/pending-approvals",
  "expense_reimbursement-list": "/expense/reimbursements",
  "expense_reimbursement-mark-paid": "/expense/reimbursements",

  // Other than List Routes
  "employee-create": [
    "/employee/create-employee",
    "/recruitment/create-employee/:id",
    "/employee/bulk-employee-add",
    "/employee/bulk-employee-update",
    "/employee/bulk-employee-profile",
  ],
  "salary-create": [
    "/payroll-management/create-salary",
    "/payroll/bulk-salary",
    "/payroll/bulk-increment",
    "/payroll/bulk-pf",
  ],
  "employee_credential-create": "/employee/bulk-credentials",
  "hr_documents-create": "/employee/bulk-upload",
  // letter_template-edit/create intentionally unmapped: the old letter
  // template creation flow (/letter-management/add-letter, update-letter)
  // is retired in favor of the Template Builder (/templates). Leaving these
  // permissions unmapped makes the router guard 403 direct navigation to
  // those routes regardless of who still holds the old permission.
  "employee-edit": "/employee/edit-employee/:id",
  "employee-view": "/user-profile/:id",
  // - Help & Support / Bug Reports
  "app_issue_reporting-list": "/help-support/app-issue-reporting",
  "app_issue_reporting-view": "/help-support/app-issue-reporting/view/:id",
  "team_management-view-employee-details": "/user-profile/:id",
  "employee-employment-view": "/employment/:id",
  "payroll-view": "/payroll-management/payroll/view/:id",
  "salary-edit": ["/payroll-management/edit-salary/:id", "/payroll/bulk-update-account-details",],
  "performance_review_submission-create-performance-review":
    "/performance-management/create-performance-review/:formId/:employeeId/:recordId/:directEmployee",
  "salary_slip-employee": [
    "/payroll-management/salary-slip-employees/:id",
    "/payroll-management/payroll/salary-slip-view/:id",
  ],
  "payroll_adjustment-edit": [
    "/payroll-management/payroll-adjustment/bulk-adjustment-upload/:id",
    "/payroll-management/payroll-adjustment/view/:id",
  ],
  "performance_review_submission-update-performance-review":
    "/performance-management/update-evaluation-form/:id",
  "self_assessment-create":
    "/performance-and-rewards/create-self-assessment/:id",
  "Apply_job_candidate-candidate-profiling": "/candidate-profile/:id",
  "bulk_upload-list": "/employee/bulk-upload",
};

export const allPermissionsWithRoute = {
  Dashboard: [
    "/admin-dashboard",
    "/employee-dashboard",
    "/chat",
    "/notifications",
    "/performance-and-rewards/dashboard",
  ],
  ESS: [
    "/employee/profile", // My Profile
    "/ess/my-portal", // My Portal
    "/ess/my-stars",
    "/attendance/my-attendance", // My Attendance
    "/attendance/check-in-out", // Attendance Check-In/Out
    "/attendance/request-break-time-change", // Break Time Change Request
    // "/basic-setup/break-time", // Break Time Setup
    "/attendance/request-shift-time-change", // Shift Time Change Request
    // "/basic-setup/shift-time", // Shift Time Setup
    "/leave/my-leaves", // My Leaves
    "/my-projects", // Projects
    "/my-letter", // My Letter
    "/asset-and-services/my-assets", // My Assets
    "/ess/my-expense-policies", // My Expense Policies
    "/ess/my-claims", // My Claims
    "/performance-and-rewards/achievement-list", // Achievements
    "/performance-and-rewards/disciplinary-action-list", // Disciplinary Actions
    "/performance-and-rewards/my-feedback", // My Feedback
    "/performance-and-rewards/my-assessment", // My Assessment
    "/performance-and-rewards/achievement-list",
    "/performance-and-rewards/disciplinary-action-list",
    "/performance-and-rewards/dashboard",
    "/targets/my-target",
    "/ess/my-gate-pass-records",
  ],
  "My Team": [
    "/my-team/my-team-dashboard",
    "/my-team/team-management",
    "/my-team/team-time-adjustment",
    "/my-team/team-leave",
    "/my-team/team-leave-summary",
    "/my-team/team-attendance",
    "/my-team/project",
    "/my-team/project/:id",
    "/employee/profile/project-tasks/:id",
    "/ess/manager-probation-evaluation",
    "/basic-setup/break-time",
    "/basic-setup/shift-time",
    "/recruitment/recruitment-requisition",
    "/my-team/performance/overview",
    "/my-team/performance/achievement",
    "/my-team/performance/disciplinary-action",
    "/my-team/performance/assessments",
    "/my-team/gate-pass-requests",
    "/my-team/team-requests",
  ],
  Employees: [
    "/employee/list-employee",
    "/employment",
    "/employee/edit-employee/:id",
    "/employee/create-employee",
    "/recruitment/create-employee/:id",
    "/user-profile/:id",
    "/employment/:id",
    // "/attendance/attendance-history",
    // "/attendance/time-adjustment-request",
    // "/attendance/ncns",
    // "/control-panel/module-settings",
    // "/basic-setup/auto-attendance",
    // "/attendance/attendance-admin",
    // "/basic-setup/leave-assign",
    // "/basic-setup/leave-history",
    "/basic-setup/shift-assign",
    "/employee/credentials-management",
    "/employee/termination",
    "/employee/promotion",
    "/employees/probation-evaluation",
    "/employees/overtime",
    "/employees/redemption-request",
    "/employee/hired-candidates",
    "/organization/hr-documents",
    "/employee/bulk-upload",
    "/employee/bulk-employee-add",
    "/employee/bulk-employee-update",
    "/employee/bulk-employee-profile",
    "/employees/gate-pass-approvals",
  ],
  Attendance: [
    "/attendance/attendance-history",
    "/attendance/time-adjustment-request",
    "/attendance/ncns",
    "/basic-setup/auto-attendance",
    "/attendance/attendance-admin",
    "/attendance-import-machiene",
    "/attendance/bulk-attendance",
    "/attendance/check-attendance",
    "/attendance/gate-pass-records",
  ],
  Leave: [
    "/basic-setup/leave-assign",
    "/basic-setup/leave-history",
    "/leave/bulk-leave",
    "/leave/bulk-leave-assign",
  ],
  "Payroll Management": [
    "/payroll-management/salary",
    "/payroll-management/create-salary",
    "/payroll-management/budget-payroll",
    "/payroll-management/generate-payroll",
    "/payroll-management/payroll-adjustment",
    "/payroll-management/pending-payroll",
    "/payroll-management/approved-payroll",
    "/payroll-management/payment-mode",
    "/payroll-management/loan-requests",
    "/payroll-management/payroll/view/:id",
    "/payroll-management/edit-salary/:id",
    "/payroll-management/salary-slip-employees/:id",
    "/payroll-management/payroll/salary-slip-view/:id",
    "/payroll-management/payroll-adjustment/bulk-adjustment-upload/:id",
    "/payroll-management/payroll-adjustment/view/:id",
    "/payroll/bulk-salary",
    "/payroll/bulk-increment",
    "/payroll/bulk-pf",
  ],
  Recruitment: [
    "/recruitment/requisition-planning",
    "/recruitment/manage-applicants",
    "/recruitment/open-vacancies",
    "/recruitment/offer-letter-tab",
    "/recruitment/interview-logs",
    "/recruitment/aptitude-test",
    "/recruitment/test-results",
    "/recruitment/cv-bank",
    "/basic-setup/additional-resource",
    "/recruitment/candidate-information",
    "/recruitment/referrals",
    "/candidate-profile/:id",
  ],
  Performance: [
    "/performance-management/evaluations-form",
    "/performance-management/create-evaluation-form",
    "/performance-management/assign-form",
    "/employee/assign-target",
    "/performance-management/performance-review",
    "/performance-management/appraisals",
    "/performance-management/achievement-list",
    "/performance-management/disciplinary-actions",
    "/performance-management/feedback",
    "/performance-management/update-evaluation-form/:id",
    "/performance-and-rewards/create-self-assessment/:id",
  ],
  "Assets and Services": [
    "/asset-and-services/assets",
    "/asset-and-services/company-services",
    "/asset-and-services/inventory",
    "/asset-and-services/card",
  ],
  "Letter Management": [
    "/letter-management/letter-generation",
    "/letter-management/issue-letter", // Issue Letter
    "/letter-management/letter-request", // Letter Request
    "/letter-management/issue-letter/:employeeId/:requestId", // Issue Letter with Params
    "/letter-management/add-policy",
    "/letter-management/all-policies",
    "/letter-management/add-letter",
    "/letter-management/update-letter",

    "/letter-management/all-letters",
    "/letter-management/all-incidents",
    "/letter-management/create-incident",
    //   "/letter-management/all-incidents",
    "/letter-management/add-incident",
    "/letter-management/incident-types",
    "/letter-management/select-letter-type",
    "/letter-management/bulk-letters",
  ],
  "Role Management": [
    "/role-management/roles-and-permissions",
    "/role-management/add-role",
    "/role-management/edit-role/:id",
    "/role-management/assign-role",
  ],
  "Reports and Analytics": [
    "/reports-and-analytics/recruitment-reports",
    "/reports-and-analytics/employee-management-reports",
    "/reports-and-analytics/performance-management-reports",
    "/reports-and-analytics/payroll-reports",
    "/reports-and-analytics/team-management-reports",
    "/reports-and-analytics/additional-reports",
    "/reports-and-analytics/basic-reports",
    "/reports-and-analytics/time-and-attendance-reports",
  ],
  "Control Panel": [
    "/control-panel/general-settings",
    "/control-panel/organization-settings",
    "/control-panel/employee-settings",
    "/control-panel/module-settings",
    "/control-panel/performance-settings",
    "/control-panel/approval-settings",
    "/control-panel/letter-settings",
    "/control-panel/notification-settings",
    "/control-panel/application-settings",
    "/basic-setup/geo-fencing",
    "/basic-setup/geo-fencing/create",
    "/basic-setup/geo-fencing/edit/:id",
    "/basic-setup/geo-fencing/map/:id",
    "/remote/geofence-creation",
    "/remote/geofence-assignment",
  ],
  Organization: [
    "/organization/handbook-details",
    "/organization/hr-documents",
    "/organization/notice-board",
    "/organization/hr-manual",
    "/organization/handbook",
    "/organization/ess-hr-manual",
    "/organization/news-letter",
    "/organization/week-poll",
  ],
  Expense: [
    "/expense/expense-categories",
    "/expense/expense-policies",
    "/expense/approval-workflow",
    "/expense/policy-assignment",
    "/expense/pending-approvals",
    "/expense/reimbursements",
  ],
};

export const indicatorsExampleData = [
  {
    id: 1,
    performance_form_id: 1,
    field_name: "Attendance",
    weightage: 20,
    is_hr: 1,
    created_at: "2024-08-09T06:29:47.000000Z",
    updated_at: "2024-08-09T06:29:47.000000Z",
  },
  {
    id: 2,
    performance_form_id: 1,
    field_name: "Policy Interests",
    weightage: 20,
    is_hr: 1,
    created_at: "2024-08-09T06:29:47.000000Z",
    updated_at: "2024-08-09T06:29:47.000000Z",
  },
  {
    id: 3,
    performance_form_id: 1,
    field_name: "Managerial Indicator",
    weightage: 15,
    is_hr: 0,
    created_at: "2024-08-09T06:29:47.000000Z",
    updated_at: "2024-08-09T06:29:47.000000Z",
    category: "managerial",
  },
  {
    id: 5,
    performance_form_id: 1,
    field_name: "Managerial Indicator 2",
    weightage: 15,
    is_hr: 0,
    created_at: "2024-08-09T06:29:47.000000Z",
    updated_at: "2024-08-09T06:29:47.000000Z",
    category: "managerial",
  },
  {
    id: 3,
    performance_form_id: 1,
    field_name: "Productivity Indicator",
    weightage: 15,
    is_hr: 0,
    created_at: "2024-08-09T06:29:47.000000Z",
    updated_at: "2024-08-09T06:29:47.000000Z",
    category: "productivity",
  },

  {
    id: 4,
    performance_form_id: 1,
    field_name: "Productivity Indicator 2",
    weightage: 15,
    is_hr: 0,
    created_at: "2024-08-09T06:29:47.000000Z",
    updated_at: "2024-08-09T06:29:47.000000Z",
    category: "productivity",
  },
];

export const assignFormExampleData = [
  {
    id: 1,
    division: {
      division_id: 1,
      division_name: "Appedology",
    },

    form: {
      form_id: 2,
      form_name: "Form Name 1",
    },

    department: {
      department_id: 1,
      department_name: "Form Name 1",
    },

    designation: {
      designation_id: 1,
      designation_name: "Designation Name 1",
    },
  },
];

export const assignedEmployeeExample = [
  {
    id: 1,
    assign_form_id: 1,
    employee_id: 1,
    hcm_id: "APD-0001",
    created_at: "2024-08-16T09:39:47.000000Z",
    updated_at: "2024-08-16T09:39:47.000000Z",
    employee: {
      id: 1,
      first_name: "Zahid",
      last_name: "Hanif",
    },
    employee_positional_info: {
      id: 1,
      hcm_id: "APD-0001",
      division_id: 1,
      department_id: 1,
      division: {
        id: 1,
        name: "Appedology Pvt. Ltd.",
      },
      department: {
        id: 1,
        name: "Software Department",
      },
    },
  },
];

export const baseRoutesBasedOnTitle = {
  Attendence: "/attendance/my-attendance",
  Attendance: "/attendance/my-attendance",
  Employees: "/employee/list-employee",
  Employee: "/employee/list-employee",
};

const reviewedEmployeeExample = {
  id: 9,
  assign_form_id: 1,
  employee_id: 10,
  hcm_id: "APD-0007",
  created_at: "2024-08-20T13:13:48.000000Z",
  updated_at: "2024-08-20T13:13:48.000000Z",
  employee: {
    id: 10,
    profile_picture: null,
    salutation_name: "Mr",
    first_name: "Asif",
    middle_name: "Demo",
    last_name: "Riaz",
    husband_father_name: "Demo",
    cnic_number: "12345-1231123-1",
    cnic_exp_date: "2030-03-11",
    personal_email_address: "asif.riaz@appedology.com",
    dob: "1990-03-11",
    city_id: 1,
    state_id: 1,
    country_id: 1,
    religion_id: 1,
    nationality_id: 1,
    blood_group_id: 1,
    gender_id: 1,
    marital_id: 1,
    created_by: 1,
    updated_by: 3,
    created_at: null,
    updated_at: "2024-08-20T13:31:41.000000Z",
    employee_positional: {
      id: 10,
      employment_personal_id: 10,
      company_id: 1,
      employee_id: "0007",
      hcm_id: "APD-0007",
      pseudo_name: "Pseudo Name",
      division_id: 1,
      business_email: "asif.riaz@appedology.com",
      employment_status_id: 1,
      shift_time_id: 1,
      designation_id: 1,
      department_id: 2,
      section_id: 1,
      team_id: 1,
      probation_ending_date: "2023-01-01",
      probation_start_date: "2023-04-01",
      date_of_confirmation: "2023-04-02",
      wfh: "no",
      campaign_id: 1,
      hiring_date: "2022-02-12",
      joining_date: "2022-02-12",
      date_of_separation: "2024-08-10",
      reporting_authority: 2,
      indirect_authority: null,
      employee_duty_type_id: 1,
      team_reporting: 1,
      created_at: null,
      updated_at: "2024-08-20T13:31:41.000000Z",
      division: {
        id: 1,
        name: "Appedology Pvt. Ltd.",
        prefix: "APD",
        eobi: 250,
        logo: "",
        email: "",
        phone_no: null,
        address:
          "2nd Floor, 66c- 68c, 25th St, Tauheed Commercial Area Defence V, Defence Housing Authority, Karachi, Karachi City, Sindh 75500",
        url: "https://hrm.appedology.pk/",
        email_domain: "appedology.com",
        city_id: 1,
        created_at: null,
        updated_at: null,
      },
      designation: {
        id: 1,
        designation_name: "developer",
        tier: "",
        standard_JD: "Full stack developer",
        created_at: "2024-08-20T13:07:46.000000Z",
        updated_at: "2024-08-20T13:07:46.000000Z",
      },
    },
  },
  assign_form: {
    id: 1,
    division_id: 1,
    department_id: 2,
    designation_id: 1,
    form_id: 5,
    quarter_id: 3,
    created_at: "2024-08-20T13:13:48.000000Z",
    updated_at: "2024-08-20T13:13:48.000000Z",
    form: {
      id: 5,
      name: "Ella Caldwell",
      division_id: 1,
      department_id: 2,
      designation_id: 1,
      project_type_id: 4,
      jd_path: "JD_Uploads/zA1KYL05xC.PNG",
      kpis: "Accusantium sint co",
      kras: "Aliqua Consequatur",
      created_at: "2024-08-20T13:13:13.000000Z",
      updated_at: "2024-08-20T13:13:13.000000Z",
    },
  },
  review_submission: {
    id: 5,
    assign_form_detail_id: 9,
    performance_form_id: 5,
    form_distribution_id: null,
    approval_status: 0,
    employee_id: 10,
    created_by: null,
    hr_comment: "Consequatur aut ut",
    manager_comment: "Nam maxime omnis acc",
    hod_comment: "asdasdasdasd",
    created_at: "2024-08-20T19:26:12.000000Z",
    updated_at: "2024-08-21T10:30:19.000000Z",
    performance_review_submission_details: [
      {
        id: 17,
        review_submission_id: 5,
        indicator_id: "12",
        indicator_title: "Attendance",
        indicator_weightage: 4,
        is_hr: 1,
        created_at: "2024-08-20T19:26:12.000000Z",
        updated_at: "2024-08-20T19:26:12.000000Z",
      },
      {
        id: 18,
        review_submission_id: 5,
        indicator_id: "13",
        indicator_title: "Policy Adherence",
        indicator_weightage: 11,
        is_hr: 1,
        created_at: "2024-08-20T19:26:12.000000Z",
        updated_at: "2024-08-20T19:26:12.000000Z",
      },
      {
        id: 19,
        review_submission_id: 5,
        indicator_id: "14",
        indicator_title: "Harriet Pugh",
        indicator_weightage: 16,
        is_hr: 0,
        created_at: "2024-08-20T19:26:12.000000Z",
        updated_at: "2024-08-20T19:26:12.000000Z",
      },
      {
        id: 20,
        review_submission_id: 5,
        indicator_id: "15",
        indicator_title: "Leo Koch",
        indicator_weightage: 29,
        is_hr: 0,
        created_at: "2024-08-20T19:26:12.000000Z",
        updated_at: "2024-08-20T19:26:12.000000Z",
      },
    ],
  },
};

const reviewSubmitExampleData = {
  id: 10,
  assign_form_detail_id: 9,
  performance_form_id: 5,
  form_distribution_id: null,
  approval_status: 0,
  hr_status: "Done",
  employee_id: 10,
  created_by: null,
  hr_comment: "Do reiciendis cillum",
  manager_comment: "Dolores exercitation",
  hod_comment: "Mollitia explicabo",
  created_at: "2024-08-21T12:19:03.000000Z",
  updated_at: "2024-08-21T12:30:20.000000Z",
  performance_review_submission_details: [
    {
      id: 37,
      review_submission_id: 10,
      indicator_id: "12",
      indicator_title: "Attendance",
      indicator_weightage: 15,
      is_hr: 1,
      created_at: "2024-08-21T12:19:03.000000Z",
      updated_at: "2024-08-21T12:19:03.000000Z",
    },
    {
      id: 38,
      review_submission_id: 10,
      indicator_id: "13",
      indicator_title: "Policy Adherence",
      indicator_weightage: 2,
      is_hr: 1,
      created_at: "2024-08-21T12:19:03.000000Z",
      updated_at: "2024-08-21T12:19:03.000000Z",
    },
    {
      id: 39,
      review_submission_id: 10,
      indicator_id: "14",
      indicator_title: "Harriet Pugh",
      indicator_weightage: 11,
      is_hr: 0,
      created_at: "2024-08-21T12:19:03.000000Z",
      updated_at: "2024-08-21T12:19:03.000000Z",
    },
    {
      id: 40,
      review_submission_id: 10,
      indicator_id: "15",
      indicator_title: "Leo Koch",
      indicator_weightage: 27,
      is_hr: 0,
      created_at: "2024-08-21T12:19:03.000000Z",
      updated_at: "2024-08-21T12:19:03.000000Z",
    },
  ],
};

const examp = {
  id: 1,
  payroll_id: 1,
  provident_fund: "9300.00",
  eobi: 250,
  payroll: {
    id: 1,
    payroll_title: "manual-payroll-2024-June",
    type: "payroll-manual",
    month: "june",
    year: "2024",
    start: "2024-06-01",
    end: "2024-06-30",
    division_id: 1,
    is_all_departments: 1,
    department_id: null,
    is_all_employee: 1,
    is_all_religion: 1,
    is_all_gender: 1,
    hr_status: "pending",
    cfo_status: "pending",
    payroll_status: "done",
    hr_approver: null,
    cfo_approver: null,
    is_amendable: 1,
    created_at: "2024-09-03T13:53:34.000000Z",
    updated_at: "2024-09-03T13:53:34.000000Z",
  },
};

const myLoanRequestsListExample = [
  {
    id: 1,
    created_at: null,
    loan_amount: "1.00",
    loan_reason: "sdfaff",
    loan_status: "Pending",
    repayment_plan: 12,
    comments: null,
  },
  {
    id: 2,
    created_at: null,
    loan_amount: "1.00",
    loan_reason: "sdfaff",
    loan_status: "Pending",
    repayment_plan: 12,
    comments: null,
  },
];

const myLoanSingleRequestExample = {
  id: 1,
  employee_id: "APD-0003",
  employee_personal_id: 3,
  department_id: 2,
  employee_name: "Adnan Sharaf",
  loan_amount: "1.00",
  loan_reason: "sdfaff",
  repayment_plan: 12,
  loan_status: "Pending",
  comments: null,
  created_at: null,
  updated_at: null,
};

const loanHistory = [
  {
    id: 1,
    payroll_id: 1,
    value: 3333,
    reason: "Monthly loan",
    payroll: {
      id: 1,
      payroll_month: "october-2024",
    },
  },
];

const myAdvanceSalaryRequestsListExample = [
  {
    id: 1,
    created_at: "2024-10-17T10:37:39.000000Z",
    advance_salary_amount: "1.00",
    advance_salary_reason: "sdfaff",
    advance_salary_status: "Pending",
    advance_salary_repayment_plan: 12,
    comments: null,
    repayment_start_date: null,
  },
];

const myAdvanceSalarySingleRequestExample = {
  id: 1,
  employee_id: "APD-0003",
  employee_personal_id: 3,
  department_id: 2,
  employee_name: "Adnan Sharaf",
  advance_salary_amount: "1.00",
  advance_salary_reason: "sdfaff",
  advance_salary_repayment_plan: 12,
  advance_salary_status: "Pending",
  comments: null,
  advance_salary_status_date: null,
  repayment_start_date: null,
  created_at: "2024-10-17T10:37:39.000000Z",
  updated_at: "2024-10-17T10:37:39.000000Z",
  advance_salary_request_details: [],
};

const form = {
  advance_salary_amount: "",
  advance_salary_reason: "",
  repayment_plan: 12,
};

export const slugBasedRoutes = {
  leave_requested: '/basic-setup/leave-history',
  time_adjustment_request: '/attendance/time-adjustment-request',
  default: "/notifications"
}